function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("filter", {
  id: "hero_svg__n",
  height: "130%",
  width: "140%",
  x: "-15%",
  y: "-15%"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "blur",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10,
  in: "blur",
  result: "offsetBlurredAlpha"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "offsetBlurredAlpha"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 541.54,
  x2: 666.19,
  y1: 246.08,
  y2: 210.85
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__o",
  x1: 399.56,
  x2: 443.71,
  xlinkHref: "#hero_svg__a",
  y1: 256.67,
  y2: 212.51
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__e",
  gradientUnits: "userSpaceOnUse",
  x1: 374.48,
  x2: 468.79,
  y1: 243.94,
  y2: 243.94
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#2d2e30"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#111112"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
}));

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__p",
  x1: 395.37,
  x2: 447.9,
  xlinkHref: "#hero_svg__a",
  y1: 241.24,
  y2: 188.71
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__c",
  gradientUnits: "userSpaceOnUse",
  x1: 388.95,
  x2: 454.32,
  y1: 213.87,
  y2: 213.87
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#23c386",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#23c386",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#23c386",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__j",
  gradientUnits: "userSpaceOnUse",
  x1: 421.97,
  x2: 421.97,
  y1: 228.42,
  y2: 60.43
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#23c386",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#23c386",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#23c386",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#23c386",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#23c386",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#23c386",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__b",
  gradientUnits: "userSpaceOnUse",
  x1: 421.47,
  x2: 421.61,
  y1: 145.4,
  y2: 191.02
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1b2828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3e4451"
}));

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__q",
  x1: 421.78,
  x2: 421.78,
  xlinkHref: "#hero_svg__b",
  y1: 118.75,
  y2: 171.37
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__r",
  x1: 421.97,
  x2: 421.97,
  xlinkHref: "#hero_svg__c",
  y1: 228.42,
  y2: 134.46
});

var _ref11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__k",
  gradientUnits: "userSpaceOnUse",
  x1: 383.16,
  x2: 461.73,
  y1: 151.67,
  y2: 151.67
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8ecda1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#8ecda1",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#8ecda1",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#8ecda1",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#8ecda1",
  stopOpacity: 0.19
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#8ecda1",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#8ecda1",
  stopOpacity: 0.02
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#8ecda1",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8ecda1",
  stopOpacity: 0.4
}));

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__d",
  gradientUnits: "userSpaceOnUse",
  x1: 404.97,
  x2: 404.97,
  y1: 139.15,
  y2: 119.27
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#23c386",
  stopOpacity: 0.62
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#23c386",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#23c386",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386",
  stopOpacity: 0
}));

var _ref13 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__s",
  x1: 413.92,
  x2: 413.92,
  xlinkHref: "#hero_svg__d",
  y1: 138.7,
  y2: 94.47
});

var _ref14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__t",
  x1: 432.28,
  x2: 432.28,
  xlinkHref: "#hero_svg__d",
  y1: 121.89,
  y2: 83.7
});

var _ref15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__u",
  x1: 419,
  x2: 419,
  xlinkHref: "#hero_svg__d",
  y1: 206.97,
  y2: 179.81
});

var _ref16 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__v",
  x1: 425.36,
  x2: 425.36,
  xlinkHref: "#hero_svg__d",
  y1: 219.8,
  y2: 202.83
});

var _ref17 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__w",
  x1: 425.36,
  x2: 425.36,
  xlinkHref: "#hero_svg__d",
  y1: 195.19,
  y2: 173.97
});

var _ref18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__x",
  x1: 446.03,
  x2: 446.03,
  xlinkHref: "#hero_svg__d",
  y1: 140.13,
  y2: 96.15
});

var _ref19 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__y",
  x1: 421.67,
  x2: 421.67,
  xlinkHref: "#hero_svg__d",
  y1: 117.61,
  y2: 102.54
});

var _ref20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__z",
  x1: 416.1,
  x2: 416.1,
  xlinkHref: "#hero_svg__d",
  y1: 111.71,
  y2: 67.58
});

var _ref21 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__A",
  x1: 374.48,
  x2: 468.79,
  xlinkHref: "#hero_svg__e",
  y1: 81.34,
  y2: 81.34
});

var _ref22 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__B",
  x1: 395.37,
  x2: 447.9,
  xlinkHref: "#hero_svg__a",
  y1: 86.53,
  y2: 34
});

var _ref23 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__C",
  x1: 400.17,
  x2: 443.1,
  xlinkHref: "#hero_svg__e",
  y1: 62.99,
  y2: 62.99
});

var _ref24 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__D",
  x1: 405.09,
  x2: 433.43,
  xlinkHref: "#hero_svg__a",
  y1: 69.94,
  y2: 41.6
});

var _ref25 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "hero_svg__E",
  cx: 422.49,
  cy: 56.97,
  gradientTransform: "matrix(0 1 -.58 0 455.43 -365.52)",
  gradientUnits: "userSpaceOnUse",
  r: 433.12
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#8cfcd7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#8cf3cc",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#8de5bd",
  stopOpacity: 0.36
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#8ddbb1",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#8ed3a8",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#8ecfa3",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8ecda1",
  stopOpacity: 0.75
}));

var _ref26 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__h",
  gradientTransform: "rotate(-150 584.242 -1021.82)",
  gradientUnits: "userSpaceOnUse",
  x1: 186.22,
  x2: 199.5,
  y1: -2034.97,
  y2: -2014.68
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d0455e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#c6425e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#aa395c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#7d2c5a",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4d1d58",
  stopOpacity: 0.99
}));

var _ref27 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__F",
  x1: 443.87,
  x2: 473.1,
  xlinkHref: "#hero_svg__a",
  y1: 119.3,
  y2: 119.3
});

var _ref28 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__G",
  x1: 436.01,
  x2: 463.56,
  xlinkHref: "#hero_svg__e",
  y1: 239.37,
  y2: 239.37
});

var _ref29 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__H",
  x1: 440.62,
  x2: 599.92,
  xlinkHref: "#hero_svg__e",
  y1: 565.88,
  y2: 565.88
});

var _ref30 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__I",
  x1: 385.95,
  x2: 665.57,
  xlinkHref: "#hero_svg__a",
  y1: 534.97,
  y2: 537.87
});

var _ref31 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__f",
  gradientUnits: "userSpaceOnUse",
  x1: 439.59,
  x2: 599.56,
  y1: 560.61,
  y2: 560.61
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
}));

var _ref32 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__J",
  x1: 245.05,
  x2: 404.34,
  xlinkHref: "#hero_svg__e",
  y1: 323.31,
  y2: 323.31
});

var _ref33 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__K",
  x1: 190.37,
  x2: 470,
  xlinkHref: "#hero_svg__a",
  y1: 292.39,
  y2: 295.3
});

var _ref34 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__L",
  x1: 244.02,
  x2: 403.99,
  xlinkHref: "#hero_svg__f",
  y1: 318.03,
  y2: 318.03
});

var _ref35 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__M",
  x1: 303.91,
  x2: 338.96,
  xlinkHref: "#hero_svg__e",
  y1: 264.12,
  y2: 264.12
});

var _ref36 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__N",
  gradientUnits: "userSpaceOnUse",
  x1: 321.44,
  x2: 321.44,
  y1: 277.38,
  y2: 212.8
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0ea179"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#0ea179",
  stopOpacity: 0.56
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#0ea179",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#0ea179",
  stopOpacity: 0
}));

var _ref37 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__O",
  x1: 306.85,
  x2: 336.03,
  xlinkHref: "#hero_svg__f",
  y1: 254.58,
  y2: 254.58
});

var _ref38 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__P",
  x1: 330.96,
  x2: 366.01,
  xlinkHref: "#hero_svg__e",
  y1: 283.54,
  y2: 283.54
});

var _ref39 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__Q",
  gradientUnits: "userSpaceOnUse",
  x1: 340.62,
  x2: 356.37,
  y1: 277.57,
  y2: 277.57
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#faac18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#faac18",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#faac18",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#faac18",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#faac18",
  stopOpacity: 0.68
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#faac18",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#faac18",
  stopOpacity: 0.4
}));

var _ref40 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__R",
  x1: 333.9,
  x2: 363.08,
  xlinkHref: "#hero_svg__f",
  y1: 274,
  y2: 274
});

var _ref41 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__S",
  x1: 360.25,
  x2: 678.83,
  xlinkHref: "#hero_svg__e",
  y1: 407.94,
  y2: 407.94
});

var _ref42 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__T",
  x1: 250.89,
  x2: 810.15,
  xlinkHref: "#hero_svg__a",
  y1: 351.69,
  y2: 357.49
});

var _ref43 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__U",
  x1: 359,
  x2: 677.32,
  xlinkHref: "#hero_svg__f",
  y1: 402.56,
  y2: 402.56
});

var _ref44 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__V",
  x1: 61.41,
  x2: 379.99,
  xlinkHref: "#hero_svg__e",
  y1: 459.19,
  y2: 459.19
});

var _ref45 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__W",
  x1: -47.95,
  x2: 511.31,
  xlinkHref: "#hero_svg__a",
  y1: 402.69,
  y2: 408.5
});

var _ref46 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__X",
  x1: 60.16,
  x2: 378.48,
  xlinkHref: "#hero_svg__f",
  y1: 453.81,
  y2: 453.81
});

var _ref47 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__Y",
  x1: 327.94,
  x2: 487.23,
  xlinkHref: "#hero_svg__e",
  y1: 502.12,
  y2: 502.12
});

var _ref48 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__Z",
  x1: 273.26,
  x2: 552.89,
  xlinkHref: "#hero_svg__a",
  y1: 471.21,
  y2: 474.11
});

var _ref49 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aa",
  x1: 326.91,
  x2: 486.88,
  xlinkHref: "#hero_svg__f",
  y1: 496.85,
  y2: 496.85
});

var _ref50 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ab",
  x1: 550.46,
  x2: 709.75,
  xlinkHref: "#hero_svg__e",
  y1: 502.12,
  y2: 502.12
});

var _ref51 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ac",
  x1: 495.78,
  x2: 775.41,
  xlinkHref: "#hero_svg__a",
  y1: 471.21,
  y2: 474.11
});

var _ref52 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ad",
  x1: 549.43,
  x2: 709.4,
  xlinkHref: "#hero_svg__f",
  y1: 496.85,
  y2: 496.85
});

var _ref53 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__g",
  gradientUnits: "userSpaceOnUse",
  x1: 518.65,
  x2: 518.65,
  y1: 433.29,
  y2: 270.74
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8ecda1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#8ecda1",
  stopOpacity: 0.95
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#8ecda1",
  stopOpacity: 0.44
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#8ecda1",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8ecda1",
  stopOpacity: 0
}));

var _ref54 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ae",
  x1: 518.56,
  x2: 518.56,
  xlinkHref: "#hero_svg__g",
  y1: 417.63,
  y2: 285.28
});

var _ref55 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__af",
  x1: 429.46,
  x2: 609.28,
  xlinkHref: "#hero_svg__e",
  y1: 354.8,
  y2: 354.8
});

var _ref56 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ag",
  x1: 429.2,
  x2: 650.76,
  xlinkHref: "#hero_svg__a",
  y1: 304.29,
  y2: 304.29
});

var _ref57 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ah",
  x1: 428.75,
  x2: 608.43,
  xlinkHref: "#hero_svg__f",
  y1: 331.44,
  y2: 331.44
});

var _ref58 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ai",
  x1: 432.92,
  x2: 604.25,
  xlinkHref: "#hero_svg__f",
  y1: 381.5,
  y2: 381.5
});

var _ref59 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aj",
  gradientTransform: "matrix(-1 .01 0 1 -1038.07 6.22)",
  x1: -1637.18,
  x2: -1591.2,
  xlinkHref: "#hero_svg__e",
  y1: 360.56,
  y2: 360.56
});

var _ref60 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ak",
  gradientTransform: "matrix(-1 .01 0 1 -1038.07 6.22)",
  x1: -1637.18,
  x2: -1591.41,
  xlinkHref: "#hero_svg__e",
  y1: 370.69,
  y2: 370.69
});

var _ref61 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__al",
  gradientTransform: "matrix(-1 0 0 1 -1368.26 0)",
  x1: -1975.98,
  x2: -1796.15,
  xlinkHref: "#hero_svg__a",
  y1: 294.72,
  y2: 294.72
});

var _ref62 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__am",
  gradientTransform: "matrix(-1 0 0 1 -1368.26 0)",
  x1: -1976.23,
  x2: -1754.67,
  xlinkHref: "#hero_svg__e",
  y1: 244.21,
  y2: 244.21
});

var _ref63 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__an",
  gradientTransform: "matrix(-1 0 0 1 -1368.26 0)",
  x1: -1976.68,
  x2: -1797.01,
  xlinkHref: "#hero_svg__f",
  y1: 271.36,
  y2: 271.36
});

var _ref64 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ao",
  gradientTransform: "matrix(-1 0 0 1 -1368.26 0)",
  x1: -1972.51,
  x2: -1801.19,
  xlinkHref: "#hero_svg__f",
  y1: 321.42,
  y2: 321.42
});

var _ref65 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ap",
  gradientTransform: "rotate(-150 690.454 -852.891)",
  x1: 459.62,
  x2: 472.9,
  xlinkHref: "#hero_svg__h",
  y1: -2046.34,
  y2: -2026.05
});

var _ref66 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aq",
  gradientTransform: "rotate(-150 693.22 -801.109)",
  x1: 523.14,
  x2: 536.42,
  xlinkHref: "#hero_svg__h",
  y1: -2014.37,
  y2: -1994.07
});

var _ref67 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ar",
  x1: 222.31,
  x2: 304.14,
  xlinkHref: "#hero_svg__a",
  y1: 290.14,
  y2: 290.14
});

var _ref68 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__as",
  gradientTransform: "matrix(-1 0 0 1 492.66 0)",
  gradientUnits: "userSpaceOnUse",
  x1: 155.06,
  x2: 390.4,
  y1: 401.49,
  y2: 401.49
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#020202"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#080809"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#131414"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#222425"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#303234"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#2e3032"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#27282a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#1b1c1d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#0a0a0a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
}));

var _ref69 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__at",
  gradientTransform: "matrix(-1 0 0 1 504.56 -3.65)",
  gradientUnits: "userSpaceOnUse",
  x1: 269.46,
  x2: 343.91,
  y1: 389.99,
  y2: 267.89
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#fff",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#fff",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#fff",
  stopOpacity: 0.43
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#fff",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#fff",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#fff",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#fff",
  stopOpacity: 0.34
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fff",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
}));

var _ref70 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__i",
  gradientTransform: "matrix(1 -1.15 0 1 -60.18 312.17)",
  gradientUnits: "userSpaceOnUse",
  x1: 197.16,
  x2: 224.89,
  y1: 253.89,
  y2: 253.89
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#fdfdfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e1e6ef"
}));

var _ref71 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__au",
  x1: 237.89,
  x2: 285.62,
  xlinkHref: "#hero_svg__i",
  y1: 282.74,
  y2: 282.74
});

var _ref72 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__av",
  x1: 197.24,
  x2: 235.95,
  xlinkHref: "#hero_svg__i",
  y1: 245.9,
  y2: 245.9
});

var _ref73 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aw",
  x1: 248.95,
  x2: 293.53,
  xlinkHref: "#hero_svg__i",
  y1: 277.06,
  y2: 277.06
});

var _ref74 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ax",
  x1: 238.03,
  x2: 268.39,
  xlinkHref: "#hero_svg__i",
  y1: 255.62,
  y2: 255.62
});

var _ref75 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ay",
  x1: 197.31,
  x2: 225.04,
  xlinkHref: "#hero_svg__i",
  y1: 231.64,
  y2: 231.64
});

var _ref76 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__az",
  x1: 197.39,
  x2: 236.75,
  xlinkHref: "#hero_svg__i",
  y1: 223.84,
  y2: 223.84
});

var _ref77 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aA",
  x1: 249.74,
  x2: 287.86,
  xlinkHref: "#hero_svg__i",
  y1: 253.34,
  y2: 253.34
});

var _ref78 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aB",
  x1: 197.46,
  x2: 225.19,
  xlinkHref: "#hero_svg__i",
  y1: 209.4,
  y2: 209.4
});

var _ref79 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aC",
  x1: 238.18,
  x2: 280.17,
  xlinkHref: "#hero_svg__i",
  y1: 236.69,
  y2: 236.69
});

var _ref80 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aD",
  x1: 197.24,
  x2: 235.95,
  xlinkHref: "#hero_svg__i",
  y1: 299.45,
  y2: 299.45
});

var _ref81 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aE",
  x1: 197.39,
  x2: 236.75,
  xlinkHref: "#hero_svg__i",
  y1: 288.5,
  y2: 288.5
});

var _ref82 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aF",
  x1: 249.74,
  x2: 287.86,
  xlinkHref: "#hero_svg__i",
  y1: 318,
  y2: 318
});

var _ref83 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aG",
  x1: 197.46,
  x2: 225.19,
  xlinkHref: "#hero_svg__i",
  y1: 274.06,
  y2: 274.06
});

var _ref84 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aH",
  x1: 238.18,
  x2: 280.17,
  xlinkHref: "#hero_svg__i",
  y1: 301.35,
  y2: 301.35
});

var _ref85 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aI",
  gradientTransform: "matrix(1 -1.15 0 1 11169.27 -6173.95)",
  gradientUnits: "userSpaceOnUse",
  x1: -10897.17,
  x2: -10996.52,
  y1: -6228.74,
  y2: -6053.53
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c680"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#00c680",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#00c680",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#00c680",
  stopOpacity: 0.77
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#00c680",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#00c680",
  stopOpacity: 0.37
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#00c680",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#00c680",
  stopOpacity: 0
}));

var _ref86 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aJ",
  gradientTransform: "matrix(1 -1.15 0 1 11265.72 -6234.31)",
  gradientUnits: "userSpaceOnUse",
  x1: -10988.71,
  x2: -11065.91,
  y1: -6206.96,
  y2: -6075.38
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00c680"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#00c680",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#00c680",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#00c680",
  stopOpacity: 0.77
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#00c680",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#00c680",
  stopOpacity: 0.38
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#00c680",
  stopOpacity: 0.16
}));

var _ref87 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aK",
  gradientTransform: "rotate(-.6 -2718.247 1548.061)",
  x1: 530.54,
  x2: 530.54,
  xlinkHref: "#hero_svg__g",
  y1: 451.81,
  y2: 321.65
});

var _ref88 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aL",
  gradientTransform: "rotate(-.6 -2718.247 1548.061)",
  x1: 530.56,
  x2: 530.56,
  xlinkHref: "#hero_svg__g",
  y1: 467.53,
  y2: 303.11
});

var _ref89 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aM",
  x1: 303.91,
  x2: 338.96,
  xlinkHref: "#hero_svg__e",
  y1: 299.32,
  y2: 299.32
});

var _ref90 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aN",
  gradientUnits: "userSpaceOnUse",
  x1: 313.57,
  x2: 329.32,
  y1: 293.35,
  y2: 293.35
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#e6345b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#e6345b",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#e6345b",
  stopOpacity: 0.91
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#e6345b",
  stopOpacity: 0.81
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#e6345b",
  stopOpacity: 0.66
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e6345b",
  stopOpacity: 0.5
}));

var _ref91 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aO",
  x1: 306.85,
  x2: 336.03,
  xlinkHref: "#hero_svg__f",
  y1: 289.78,
  y2: 289.78
});

var _ref92 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aP",
  x1: 505.73,
  x2: 535.41,
  xlinkHref: "#hero_svg__a",
  y1: 549.95,
  y2: 520.28
});

var _ref93 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aQ",
  x1: 488.88,
  x2: 552.26,
  xlinkHref: "#hero_svg__e",
  y1: 541.4,
  y2: 541.4
});

var _ref94 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aR",
  x1: 502.92,
  x2: 538.22,
  xlinkHref: "#hero_svg__a",
  y1: 539.59,
  y2: 504.28
});

var _ref95 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aS",
  x1: 498.6,
  x2: 542.54,
  xlinkHref: "#hero_svg__c",
  y1: 521.19,
  y2: 521.19
});

var _ref96 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aT",
  x1: 520.8,
  x2: 520.8,
  xlinkHref: "#hero_svg__j",
  y1: 530.97,
  y2: 451.81
});

var _ref97 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__l",
  gradientTransform: "matrix(.5 .87 .87 -.5 -426.3 49.43)",
  gradientUnits: "userSpaceOnUse",
  x1: 848.03,
  x2: 878.91,
  y1: 600.27,
  y2: 600.27
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f2fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dcddf9"
}));

var _ref98 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__m",
  gradientTransform: "matrix(.5 .87 .87 -.5 -426.3 49.43)",
  gradientUnits: "userSpaceOnUse",
  x1: 848.02,
  x2: 878.92,
  y1: 587.35,
  y2: 587.35
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9f8fe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f4f4fc"
}));

var _ref99 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aU",
  x1: 520.8,
  x2: 520.8,
  xlinkHref: "#hero_svg__c",
  y1: 530.97,
  y2: 489.59
});

var _ref100 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aV",
  x1: 494.71,
  x2: 547.51,
  xlinkHref: "#hero_svg__k",
  y1: 496.26,
  y2: 496.26
});

var _ref101 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aW",
  x1: 488.88,
  x2: 552.26,
  xlinkHref: "#hero_svg__e",
  y1: 465.85,
  y2: 465.85
});

var _ref102 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aX",
  x1: 502.92,
  x2: 538.22,
  xlinkHref: "#hero_svg__a",
  y1: 469.34,
  y2: 434.04
});

var _ref103 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aY",
  x1: 615.41,
  x2: 645.09,
  xlinkHref: "#hero_svg__a",
  y1: 485.79,
  y2: 456.11
});

var _ref104 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__aZ",
  x1: 598.56,
  x2: 661.95,
  xlinkHref: "#hero_svg__e",
  y1: 477.24,
  y2: 477.24
});

var _ref105 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__ba",
  x1: 612.6,
  x2: 647.91,
  xlinkHref: "#hero_svg__a",
  y1: 475.43,
  y2: 440.12
});

var _ref106 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bb",
  x1: 608.28,
  x2: 652.22,
  xlinkHref: "#hero_svg__c",
  y1: 457.03,
  y2: 457.03
});

var _ref107 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bc",
  x1: 630.48,
  x2: 630.48,
  xlinkHref: "#hero_svg__j",
  y1: 466.81,
  y2: 387.64
});

var _ref108 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bd",
  gradientTransform: "rotate(119.9 769.157 477.955)",
  x1: 786.03,
  x2: 816.91,
  xlinkHref: "#hero_svg__l",
  y1: 623.88,
  y2: 623.88
});

var _ref109 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__be",
  gradientTransform: "rotate(119.9 769.157 477.955)",
  x1: 786.02,
  x2: 816.92,
  xlinkHref: "#hero_svg__m",
  y1: 610.96,
  y2: 610.96
});

var _ref110 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bf",
  x1: 630.48,
  x2: 630.48,
  xlinkHref: "#hero_svg__c",
  y1: 466.81,
  y2: 425.43
});

var _ref111 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bg",
  x1: 604.39,
  x2: 657.2,
  xlinkHref: "#hero_svg__k",
  y1: 432.09,
  y2: 432.09
});

var _ref112 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bh",
  x1: 598.56,
  x2: 661.95,
  xlinkHref: "#hero_svg__e",
  y1: 401.69,
  y2: 401.69
});

var _ref113 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bi",
  x1: 612.6,
  x2: 647.91,
  xlinkHref: "#hero_svg__a",
  y1: 405.18,
  y2: 369.88
});

var _ref114 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bj",
  x1: 390.8,
  x2: 420.48,
  xlinkHref: "#hero_svg__a",
  y1: 485.79,
  y2: 456.11
});

var _ref115 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bk",
  x1: 373.95,
  x2: 437.33,
  xlinkHref: "#hero_svg__e",
  y1: 477.24,
  y2: 477.24
});

var _ref116 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bl",
  x1: 387.98,
  x2: 423.29,
  xlinkHref: "#hero_svg__a",
  y1: 475.43,
  y2: 440.12
});

var _ref117 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bm",
  x1: 383.67,
  x2: 427.61,
  xlinkHref: "#hero_svg__c",
  y1: 457.03,
  y2: 457.03
});

var _ref118 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bn",
  x1: 405.86,
  x2: 405.86,
  xlinkHref: "#hero_svg__j",
  y1: 466.81,
  y2: 387.64
});

var _ref119 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bo",
  gradientTransform: "translate(-438.61 -351.69)",
  x1: 831.45,
  x2: 862.33,
  xlinkHref: "#hero_svg__l",
  y1: 789.07,
  y2: 789.07
});

var _ref120 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bp",
  gradientTransform: "translate(-438.61 -351.69)",
  x1: 831.44,
  x2: 862.34,
  xlinkHref: "#hero_svg__m",
  y1: 776.15,
  y2: 776.15
});

var _ref121 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bq",
  x1: 405.86,
  x2: 405.86,
  xlinkHref: "#hero_svg__c",
  y1: 466.81,
  y2: 425.43
});

var _ref122 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__br",
  x1: 379.78,
  x2: 432.58,
  xlinkHref: "#hero_svg__k",
  y1: 432.09,
  y2: 432.09
});

var _ref123 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bs",
  x1: 373.95,
  x2: 437.33,
  xlinkHref: "#hero_svg__e",
  y1: 401.69,
  y2: 401.69
});

var _ref124 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bt",
  x1: 387.98,
  x2: 423.29,
  xlinkHref: "#hero_svg__a",
  y1: 405.18,
  y2: 369.88
});

var _ref125 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bu",
  gradientTransform: "matrix(-.87 -.5 .5 -.87 1852.28 -1515.63)",
  x1: 299.64,
  x2: 312.92,
  xlinkHref: "#hero_svg__h",
  y1: -2189.43,
  y2: -2169.14
});

var _ref126 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bv",
  x1: 445.98,
  x2: 477.33,
  xlinkHref: "#hero_svg__e",
  y1: 182.45,
  y2: 206.06
});

var _ref127 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bw",
  gradientTransform: "matrix(.5 .87 .87 -.5 2296.47 -1136.2)",
  x1: 290.15,
  x2: 303.43,
  xlinkHref: "#hero_svg__h",
  y1: -2203.69,
  y2: -2183.4
});

var _ref128 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bx",
  x1: 541.86,
  x2: 631.28,
  xlinkHref: "#hero_svg__a",
  y1: 206.07,
  y2: 176.65
});

var _ref129 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__by",
  gradientTransform: "matrix(-.87 -.5 .5 -.87 2081.73 -1302.87)",
  x1: 487.22,
  x2: 500.5,
  xlinkHref: "#hero_svg__h",
  y1: -2308.4,
  y2: -2288.11
});

var _ref130 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bz",
  gradientTransform: "rotate(-150 796.008 -900.258)",
  x1: 475.14,
  x2: 488.41,
  xlinkHref: "#hero_svg__h",
  y1: -2204.23,
  y2: -2183.94
});

var _ref131 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bA",
  x1: 434.41,
  x2: 506.79,
  xlinkHref: "#hero_svg__e",
  y1: 420.45,
  y2: 374
});

var _ref132 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bB",
  gradientTransform: "matrix(.5 .87 .87 -.5 2256.44 -1136.45)",
  x1: 498.89,
  x2: 512.17,
  xlinkHref: "#hero_svg__h",
  y1: -2288.53,
  y2: -2268.24
});

var _ref133 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bC",
  gradientTransform: "matrix(.5 .87 .87 -.5 2255.96 -1137.07)",
  x1: 484.93,
  x2: 498.21,
  xlinkHref: "#hero_svg__h",
  y1: -2187.57,
  y2: -2167.28
});

var _ref134 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bD",
  x1: 543.76,
  x2: 607.99,
  xlinkHref: "#hero_svg__a",
  y1: 383.22,
  y2: 419.21
});

var _ref135 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bE",
  gradientTransform: "rotate(-150 784.702 -880.851)",
  x1: 490.54,
  x2: 503.82,
  xlinkHref: "#hero_svg__h",
  y1: -2177.56,
  y2: -2157.27
});

var _ref136 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bF",
  gradientTransform: "rotate(-150 780.543 -822.294)",
  x1: 557.4,
  x2: 570.68,
  xlinkHref: "#hero_svg__h",
  y1: -2132.73,
  y2: -2112.43
});

var _ref137 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bG",
  x1: 307.95,
  x2: 386.53,
  xlinkHref: "#hero_svg__a",
  y1: 350.21,
  y2: 407.5
});

var _ref138 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bH",
  gradientTransform: "rotate(-150 877.178 -1042.467)",
  x1: 361.16,
  x2: 374.44,
  xlinkHref: "#hero_svg__h",
  y1: -2397.7,
  y2: -2377.41
});

var _ref139 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bI",
  gradientTransform: "matrix(-.87 -.5 .5 -.87 1919.32 -1536.37)",
  x1: 297.55,
  x2: 310.83,
  xlinkHref: "#hero_svg__h",
  y1: -2239.21,
  y2: -2218.92
});

var _ref140 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__bJ",
  gradientUnits: "userSpaceOnUse",
  x1: 640.34,
  x2: 537.76,
  y1: 275.23,
  y2: 339.88
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#020202"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#1b1c1d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#2b2c2e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#303234"
}));

var _ref141 = /*#__PURE__*/React.createElement("g", {
  fill: "#231f20",
  filter: "url(#hero_svg__n)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 250.46,
  opacity: 0.5,
  rx: 47.16,
  ry: 27.23
}), /*#__PURE__*/React.createElement("path", {
  d: "M595.25 553.43l-68.86 40.41a13.46 13.46 0 01-13.63 0l-68.86-40.41a7.1 7.1 0 010-12.26l68.91-39.78a13.48 13.48 0 0113.46 0l68.9 39.78a7.1 7.1 0 01.08 12.26zM399.68 310.85l-68.87 40.41a13.44 13.44 0 01-13.62 0l-68.86-40.41a7.08 7.08 0 010-12.25l68.9-39.78a13.43 13.43 0 0113.46 0l68.9 39.78a7.09 7.09 0 01.09 12.25zm269.82 66.34L531.77 458a26.93 26.93 0 01-27.24 0L366.8 377.19a14.18 14.18 0 01.09-24.51l137.8-79.56a26.91 26.91 0 0126.92 0l137.8 79.56a14.18 14.18 0 01.09 24.51zm-298.84 51.25l-137.73 80.81a26.89 26.89 0 01-27.24 0L68 428.44a14.18 14.18 0 01.09-24.51l137.8-79.56a26.91 26.91 0 0126.92 0l137.8 79.56a14.18 14.18 0 01.05 24.51zm334.43 61.23l-68.87 40.41a13.44 13.44 0 01-13.62 0l-68.86-40.41a7.08 7.08 0 010-12.25l68.9-39.78a13.43 13.43 0 0113.46 0l68.9 39.78a7.09 7.09 0 01.09 12.25zm-222.53 0l-68.86 40.41a13.44 13.44 0 01-13.62 0l-68.86-40.41a7.08 7.08 0 010-12.25l68.9-39.78a13.43 13.43 0 0113.46 0l68.9 39.78a7.08 7.08 0 01.08 12.25z",
  opacity: 0.5
}));

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M534.11 224.08l1.36-.2 1.37-.19 1.37-.2 1.36-.19 1.37-.2 1.37-.19 2.73-.39 1.36-.2 1.37-.19 2.73-.39 5.5-.74c0-.38-.07-.71-.1-1s0-.56 0-.76v-.62a26.85 26.85 0 013.45-12.48 14 14 0 013.25-4c.25-.26.46-.29.65-.47s.17-.06.25-.11.15-.1.2-.09a.25.25 0 00.14-.06h.15a3.76 3.76 0 011.59.71 18.15 18.15 0 013.32 3.07 12.29 12.29 0 01.88 1.09c.29.39.6.75.89 1.15.56.87 1.15 1.67 1.71 2.58s1.1 1.83 1.63 2.8l1.55 3c6.73 13.83 9.4 30.06 9.21 46.34v1.47c0 1 0 2.44-.17 4.38l-.22 3.29-.38 4c-.18 1.44-.34 3-.61 4.68-.12.83-.25 1.7-.4 2.55l-.24 1.31-.23 1.15 5.38 1.23 2.69.61 1.35.31 1.34.3 2.7.62 1.34.3 1.35.31 1.34.31 1.35.3 1.34.31 1.35.31c.18-.8.26-1.29.38-1.9l.3-1.66c.2-1.09.35-2.11.5-3.11.31-2 .51-3.81.72-5.51l.44-4.65.26-3.81c.14-2.26.15-4 .2-5.09l.05-1.7a145.51 145.51 0 00-2.39-28.52 110.87 110.87 0 00-9.14-27.94l-2-3.83c-.69-1.28-1.48-2.56-2.23-3.83s-1.68-2.55-2.53-3.81c-.46-.64-1-1.27-1.45-1.9s-.94-1.26-1.53-1.89A41.48 41.48 0 00582 187a34.23 34.23 0 00-4.43-3.47 25.23 25.23 0 00-12.75-4.24c-.76 0-1.53 0-2.29.06-.38 0-.77 0-1.14.07l-1.12.18c-.75.14-1.5.27-2.22.46s-1.4.44-2.09.68a15.8 15.8 0 00-2 .83c-.62.31-1.28.61-1.85.95a27.7 27.7 0 00-3.23 2.2 35.49 35.49 0 00-8.71 10.28 48.37 48.37 0 00-4.68 11.26 47.13 47.13 0 00-1.75 12.17v1.38c0 .47 0 1 .08 1.74z",
  fill: "url(#hero_svg__a)"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M461.27 259.53c0 23.81-79.27 23.81-79.27 0v-30.85h79.27z"
});

var _ref144 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 234.59,
  fill: "url(#hero_svg__o)",
  rx: 39.64,
  ry: 19.44
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M468.79 251.67c0 28.33-94.31 28.33-94.31 0V215h94.31z",
  fill: "url(#hero_svg__e)"
});

var _ref146 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 214.98,
  fill: "url(#hero_svg__p)",
  rx: 47.16,
  ry: 23.13
});

var _ref147 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 213.87,
  fill: "url(#hero_svg__c)",
  rx: 32.69,
  ry: 11.65
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M384.85 211.69c0 22.3 74.25 22.3 74.25 0V60.43h-74.25z",
  fill: "url(#hero_svg__j)",
  opacity: 0.17
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M455.29 179.16s1.18-3.57-.93-5c-.45-.3-3.43-1.66-3.43-1.66.75-3.73 2-12.45-1.2-16-3.64-4.08-12.78-9.79-17.85-9.76a7.52 7.52 0 00-4 1.07l-14.4-.81-.06.08a8.63 8.63 0 00-2.17-.29c-5.06 0-14.2 5.68-17.84 9.76-3.16 3.55-2 12.27-1.2 16 0 0-3 1.36-3.43 1.66-2.11 1.41-.94 5-.94 5l2-2.62 2.67-.24s-2.19.92-2.77 2.36c-.93 2.33 2 4.28 2 4.28l-.08-2.85 2-1.27a4.55 4.55 0 00-.54 2.75c.53 1.8 3.2 2 3.2 2l-1-2.26 1.11-1.59s4.3.39 4.6-3c0 0-2.25-10 .18-12.68a21.48 21.48 0 014.36-2.41c-.21 9.34 3.09 14.73 3.09 14.73a26 26 0 00-10.43 8.39c-4.85 6.84 7.14 15.51 7.14 15.51-1.87-.05-3.19 1.5-4.31 3.67l3.58-.22a2.69 2.69 0 00-.57 2.9l3.44-1.23a2.16 2.16 0 00-.27 3.38s5.3-2.64 6.47-6.4-3.37-10.45-3.37-10.45 3.21-6.44 11.91-6.36 11 6.57 11 6.57-4.24 6.61-3 10.39 6.59 6.53 6.59 6.53a2.83 2.83 0 00-.33-3.39L440 207c.77-1.05.61-2-.62-2.92l3.58.29a5 5 0 00-4.37-3.75s11.84-8.45 6.87-15.37c-4.32-6-11.63-8.41-11.63-8.41a40.33 40.33 0 003.88-15.07 20.36 20.36 0 014.17 2.32c2.43 2.73.18 12.68.18 12.68.3 3.35 4.6 3 4.6 3l1.11 1.59-1 2.26s2.67-.18 3.2-2a4.55 4.55 0 00-.54-2.75l2 1.27-.08 2.85s3-1.95 2-4.28c-.58-1.44-2.77-2.36-2.77-2.36l2.67.24z",
  fill: "url(#hero_svg__b)"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M450.59 125.73a.76.76 0 00-.42.15 23.83 23.83 0 01-11.1 4.17 9.31 9.31 0 00-3 .71 5 5 0 00-1.7 1.48c-2.58-3.09-6.62-4.63-12-4.58h-1.1c-5.4 0-9.41 1.67-11.92 4.81a5.08 5.08 0 00-1.74-1.44 9.35 9.35 0 00-3-.66 23.82 23.82 0 01-11.18-4 .79.79 0 00-1 .07.79.79 0 00-.2.94c.13.29.65 1.61.8 2 .64 1.61 3 5 3.46 9 .05.39.13.83.23 1.29l2.28.33-1.82 1.41a9.8 9.8 0 002.76 4.2l2.69-1.4-1 2.46a8.94 8.94 0 004.66.47 8.27 8.27 0 00-.23 2.79 5 5 0 002 3.42c1.53 1.21 3.94 2.06 7.36 2.59a2.2 2.2 0 011.41 1.2c.3.89 1.95 1.31 5.14 1.33h.15a13.46 13.46 0 004-.53 1.58 1.58 0 001.07-.89 2.22 2.22 0 011.39-1.24c3.59-.63 6.06-1.58 7.54-2.91a4.83 4.83 0 001.7-3.63v-.08a15.41 15.41 0 00-.3-2.35 11.58 11.58 0 001.86.07l-.35-2.39 1.67 2.1.16-1.4 1.05 1.11a7.57 7.57 0 003.31-2.86l-2.72-2.27 3.52.78a11.09 11.09 0 001-3.21l-1.58-.77 1.76-.28-2.2-1.09h2.42c.7-3.5 2.59-6.36 3.14-7.79.13-.35.64-1.66.77-2a.86.86 0 00.08-.36.81.81 0 00-.82-.75z",
  fill: "#211f32"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M450.59 125.73a.76.76 0 00-.42.15 23.83 23.83 0 01-11.1 4.17 9.31 9.31 0 00-3 .71 5 5 0 00-1.7 1.48c-2.58-3.09-6.62-4.63-12-4.58h-1.1c-5.4 0-9.41 1.67-11.92 4.81a5.08 5.08 0 00-1.74-1.44 9.35 9.35 0 00-3-.66 23.82 23.82 0 01-11.18-4 .79.79 0 00-1 .07.79.79 0 00-.2.94c.13.29.65 1.61.8 2 .64 1.61 3 5 3.46 9 .05.39.13.83.23 1.29l2.28.33-1.82 1.41a9.8 9.8 0 002.76 4.2l2.69-1.4-1 2.46a8.94 8.94 0 004.66.47 8.27 8.27 0 00-.23 2.79 5 5 0 002 3.42c1.53 1.21 3.94 2.06 7.36 2.59a2.2 2.2 0 011.41 1.2c.3.89 1.95 1.31 5.14 1.33h.15a13.46 13.46 0 004-.53 1.58 1.58 0 001.07-.89 2.22 2.22 0 011.39-1.24c3.59-.63 6.06-1.58 7.54-2.91a4.83 4.83 0 001.7-3.63v-.08a15.41 15.41 0 00-.3-2.35 11.58 11.58 0 001.86.07l-.35-2.39 1.67 2.1.16-1.4 1.05 1.11a7.57 7.57 0 003.31-2.86l-2.72-2.27 3.52.78a11.09 11.09 0 001-3.21l-1.58-.77 1.76-.28-2.2-1.09h2.42c.7-3.5 2.59-6.36 3.14-7.79.13-.35.64-1.66.77-2a.86.86 0 00.08-.36.81.81 0 00-.82-.75z",
  fill: "url(#hero_svg__q)"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M442.59 133c-3.12 1.33-5.59 2.65-6.15 4.87s.27 5.28.94 8c.08.3.15.6.22.9a13.12 13.12 0 001.86.14l-.35-2.39 1.67 2.1.16-1.4 1.05 1.11a7.57 7.57 0 003.31-2.86l-2.72-2.27 3.52.78a11.09 11.09 0 001-3.21l-1.58-.77 1.76-.28-2.28-1.09h2.42c.7-3.5 2.59-6.36 3.14-7.79.13-.35.64-1.66.77-2-2.42 3.54-5.6 4.84-8.74 6.16zm-19.36-2.79a6.62 6.62 0 012.4-.07c.47.06.79.41.54.64a2.68 2.68 0 01-2.06.41c-1-.18-1.31-.68-.88-1zm-.13 1.87c1.11 0 .51 1.16-.15 1.3s-1.69-.2-1.56-.61 1.13-.72 1.71-.69zm-3.49-2.03a2.19 2.19 0 011.89 1.12c.09.46-.48.66-1.87.87s-2.65-.44-2.66-.82 1.84-1.09 2.64-1.17zm-12.26 8.14c-.51-1.16-1.07-2.83-4.72-4.14h-.07a21.31 21.31 0 01-4.34-1.76 23 23 0 01-6-4.84c.13.29.65 1.61.8 2 .64 1.61 3 5 3.46 9 .05.39.13.83.23 1.29l2.29.26-1.82 1.41a9.8 9.8 0 002.76 4.2l2.69-1.4-1 2.46a8.18 8.18 0 004.67.47c.07-.3.15-.6.23-.87.76-2.54 1.75-5.99.82-8.08zm24.75 8.07c-.1 1.25-1 2-3.29 2h-.9c-2.51-.16-3.61-.51-6.34-.5s-3.82.37-6.33.53h-.9c-2.33 0-3.19-.69-3.3-2-1.9 1.57.56 3.81 2.44 4.75a18.19 18.19 0 007.73 1.51h.79a18.4 18.4 0 007.73-1.55c1.85-.93 4.33-3.19 2.41-4.76z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M412.13 149.64c-.58-.48-1.46-1.34-1.31-2.19 0 0 .07-.06.1 0a2.79 2.79 0 001.93 1.17.05.05 0 010 .09l-.67.94a.05.05 0 01-.08 0zm1.41.95a7.76 7.76 0 01-.94-.59.07.07 0 010-.11l.72-1a.06.06 0 01.1 0l.26 1.61c0 .09 0 .13-.12.09zm.6.02l-.28-1.7a.18.18 0 01.17-.2h1.32a.17.17 0 01.15.26l-1.26 1.7a.06.06 0 01-.1 0zm2.91 1.12a14.53 14.53 0 01-2.26-.6.22.22 0 01-.1-.34l1.48-2h.09l1 2.62a.23.23 0 01-.25.31zm.8-.08l-1.09-2.82a.22.22 0 01.18-.3l.9-.11c.53-.07 1.05-.13 1.62-.18a.17.17 0 01.16.25l-1.62 3.17a.05.05 0 01-.1 0zm2.97.46c-.76 0-1.48-.08-2.15-.15a.22.22 0 01-.17-.33l1.43-2.75a.05.05 0 01.1 0l1 2.93a.23.23 0 01-.22.3zm.82-.26a.06.06 0 01-.11 0l-1.17-3.38a.23.23 0 01.21-.3h2a.23.23 0 01.21.3l-1.15 3.39zm2.84.15c-.67.07-1.39.12-2.15.16a.23.23 0 01-.22-.3l1-2.93a.06.06 0 01.11 0l1.44 2.75a.22.22 0 01-.17.33zm.72-.36l-1.69-3.16a.17.17 0 01.16-.25c.58.05 1.09.11 1.62.17l1 .12a.16.16 0 01.14.22l-1.1 2.89a.05.05 0 01-.1 0zm3.15-.54a14.07 14.07 0 01-2.25.61.23.23 0 01-.25-.31l1-2.63a.06.06 0 01.1 0l1.49 2a.23.23 0 01-.11.35zm.92-2.23l-.26 1.71a.05.05 0 01-.1 0l-1.27-1.69a.16.16 0 01.14-.26h1.32a.16.16 0 01.17.19zm1.27 1.13a7.76 7.76 0 01-.94.59c-.08 0-.13 0-.12-.09l.25-1.61a.06.06 0 01.1 0l.73 1a.08.08 0 010 .12zm.82-.71l-.33.3a.06.06 0 01-.09 0l-.67-.94a.05.05 0 010-.09 3.41 3.41 0 001.24-.46 2 2 0 00.68-.71.06.06 0 01.11 0 .94.94 0 010 .29 2.83 2.83 0 01-1 1.6z",
  fill: "#fff"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M410.16 138.6c1.84-.06 4.15 2 7.66 3.38 1.28.5 2.66.9 2.86 1a15.49 15.49 0 01-2.08.25 4.07 4.07 0 01-3.72 2.05 3.7 3.7 0 01-3.93-3.1 4.86 4.86 0 01-.07-1.32 10.61 10.61 0 013.37.37 9.84 9.84 0 00-3.67-1.28 5.6 5.6 0 00-1.86.28s.33-1.56 1.44-1.59zm23.12 1.28a9.82 9.82 0 00-3.67 1.29 10.5 10.5 0 013.37-.38 4.49 4.49 0 01-.07 1.32 3.67 3.67 0 01-3.91 3.11 4.1 4.1 0 01-3.73-2 13.61 13.61 0 01-2.08-.25c.21 0 1.58-.46 2.86-1 3.51-1.39 5.79-3.47 7.64-3.42 1.11 0 1.43 1.59 1.43 1.59a5.48 5.48 0 00-1.84-.28z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M429.6 141.19a10.44 10.44 0 013.36-.38 4.86 4.86 0 01-.06 1.32 3.69 3.69 0 01-3.91 3.12 4.1 4.1 0 01-3.72-2 23.87 23.87 0 004.33-2zm-10.99 2.01a4.07 4.07 0 01-3.72 2.05 3.67 3.67 0 01-3.91-3.09 4.94 4.94 0 01-.08-1.33 10.61 10.61 0 013.37.37 24.22 24.22 0 004.34 2z",
  fill: "#23c386"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M417.14 143.72c.12-.7-3.67-1.63-3.67-1.63-1.2-.44-1.12.34-.9.72s.92 1.77 2.09 1.93 2.4-.55 2.48-1.02zm14.29-.93a3.63 3.63 0 01-2.07 1.94c-1.15.26-2.36-.32-2.49-1s3.66-1.64 3.66-1.64c.52-.17 1.4-.3.9.7z",
  fill: "#69e3b4"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M415.72 142.83s1.23.3 1.26.86-1.81-.63-2.27-.83 0-.38 1 0zm12.54 0s-1.23.31-1.25.86 1.8-.64 2.26-.84 0-.38-1 0z",
  fill: "#fff"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M384.85 211.69c0 22.3 74.25 22.3 74.25 0V82.8h-74.25z",
  fill: "url(#hero_svg__r)",
  opacity: 0.52
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M380.56 214.23c0 24.88 82.82 24.88 82.82 0V70.45h-82.82z",
  fill: "url(#hero_svg__k)",
  opacity: 0.52
});

var _ref160 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M404.97 119.27v19.88",
  stroke: "url(#hero_svg__d)",
  strokeWidth: 1.43
}), /*#__PURE__*/React.createElement("path", {
  d: "M413.92 138.7V94.47",
  stroke: "url(#hero_svg__s)",
  strokeWidth: 1.43
}), /*#__PURE__*/React.createElement("path", {
  d: "M432.28 121.89V83.7",
  stroke: "url(#hero_svg__t)",
  strokeWidth: 1.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M419 179.81v27.16",
  stroke: "url(#hero_svg__u)",
  strokeWidth: 1.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.36 219.8v-16.97",
  stroke: "url(#hero_svg__v)",
  strokeWidth: 1.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.36 173.97v21.22",
  stroke: "url(#hero_svg__w)",
  strokeWidth: 1.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.03 140.13V96.15",
  stroke: "url(#hero_svg__x)",
  strokeWidth: 1.47
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.67 117.61v-15.07",
  stroke: "url(#hero_svg__y)",
  strokeWidth: 1.54
}), /*#__PURE__*/React.createElement("path", {
  d: "M416.1 111.71V67.58",
  stroke: "url(#hero_svg__z)",
  strokeWidth: 1.54
}));

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M468.79 81.17c0 28.32-94.31 28.32-94.31 0V60.26h94.31z",
  fill: "url(#hero_svg__A)"
});

var _ref162 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 60.26,
  fill: "url(#hero_svg__B)",
  rx: 47.16,
  ry: 23.13
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M443.1 62.91c0 12.9-42.93 12.9-42.93 0V53.4h42.93z",
  fill: "url(#hero_svg__C)"
});

var _ref164 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.64,
  cy: 53.4,
  fill: "url(#hero_svg__D)",
  rx: 21.47,
  ry: 10.53
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M474.81 97.62l-4.75 34.15-11 78.72-.41 2.91h-.05a11.91 11.91 0 01-.44 2.34c-8.13 17.6-69.35 16.88-73.16-2.15v-.19l-11.4-81.63-4.76-34.15z",
  fill: "url(#hero_svg__E)"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M436.88 54.24c-.07 9.07-30.28 8.84-30.21-.23l.05-6.7 30.21.23z"
});

var _ref167 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.83,
  cy: 47.43,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 421.817 47.44)"
});

var _ref168 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.57,
  cy: 36.92,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 421.556 36.93)"
});

var _ref169 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.68,
  cy: 42.52,
  fill: "url(#hero_svg__h)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 421.673 42.526)"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M410.79 47.43h22.08c.05-5.16.86-9.32 2.09-12a11.61 11.61 0 013.54-4.93 4.58 4.58 0 012.12-1c.44-.09.65-.08.65-.11a5 5 0 012.39.63 7.23 7.23 0 012.49 2.44 14.19 14.19 0 011.85 4.45 28.2 28.2 0 01.67 6V231.3h22.08V42.86a49.72 49.72 0 00-1.32-11.26 36.34 36.34 0 00-4.94-11.4 29.22 29.22 0 00-10-9.41 27 27 0 00-14.19-3.47l-1 .09a21.07 21.07 0 00-3.06.43 26.76 26.76 0 00-10.86 4.89 33.57 33.57 0 00-10.68 14c-2.7 6.03-3.84 13.1-3.91 20.7z",
  fill: "url(#hero_svg__F)"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M409.45 46.4l-.1-9.64c0 3.31 5.43 6 12.2 6.09s12.24-2.6 12.26-5.9l.1 9.63c-.05 7.35-24.52 7.16-24.46-.18z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M463.56 218.87l-5.08-2.15-2.54-1.08-1.27-.54-1.27-.53-2.55-1.08-1.27-.54-1.27-.54-1.27-.54-1.27-.53-1.27-.54-1.27-.54a86.67 86.67 0 00-5 17.06c-.22 1.22-.45 2.38-.63 3.49l-.44 3.18c-.31 2-.42 3.82-.6 5.43q-.37 4.8-.43 7.19L436 249v4.81c0 1.6.07 3.6.18 6 .08 1.21.13 2.5.25 3.92l.19 2.21.12 1.19.15 1.36 1.37-.18 1.37-.18L441 268l1.37-.18 1.37-.18 1.36-.18 2.74-.36 1.37-.18 1.37-.18 2.73-.36 5.48-.72-.19-1.76-.15-1.82c-.1-1.18-.15-2.3-.22-3.32-.09-2.06-.13-3.78-.15-5.16v-4.13l.07-2q0-2 .36-6.06c.16-1.33.23-2.85.49-4.48l.36-2.58c.14-.89.33-1.81.5-2.77a65.35 65.35 0 013.7-12.71z",
  fill: "url(#hero_svg__G)"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M598.75 536.36H440.4v4.93c-.06 2.43 1.1 10.46 3.49 11.86l68.86 40.41a13.46 13.46 0 0013.63 0l68.86-40.41a7 7 0 003.49-6.29z",
  fill: "url(#hero_svg__H)"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M595.25 542.15l-68.86 40.4a13.46 13.46 0 01-13.63 0l-68.86-40.4a7.1 7.1 0 010-12.26l68.91-39.78a13.48 13.48 0 0113.46 0l68.9 39.78a7.1 7.1 0 01.08 12.26z",
  fill: "url(#hero_svg__I)"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M598.75 536a7 7 0 01-3.5 6.14l-68.86 40.4a13.46 13.46 0 01-13.63 0l-68.86-40.4a7 7 0 01-3.49-5.79",
  fill: "none",
  stroke: "url(#hero_svg__f)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M403.18 293.78H244.83v4.93c-.06 2.43 1.09 10.46 3.49 11.86L317.19 351a13.44 13.44 0 0013.62 0l68.87-40.41a7 7 0 003.49-6.29z",
  fill: "url(#hero_svg__J)"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M399.68 299.57L330.81 340a13.44 13.44 0 01-13.62 0l-68.86-40.41a7.09 7.09 0 010-12.26l68.9-39.78a13.48 13.48 0 0113.46 0l68.9 39.78a7.1 7.1 0 01.09 12.24z",
  fill: "url(#hero_svg__K)"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M403.18 293.43a7 7 0 01-3.5 6.14L330.81 340a13.44 13.44 0 01-13.62 0l-68.86-40.41a7 7 0 01-3.5-5.79",
  fill: "none",
  stroke: "url(#hero_svg__L)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M338.94 279.34v-15.22h-35v15.22c-.1 2.66 1.59 5.34 5.12 7.38 6.84 3.95 17.94 3.95 24.78 0 3.51-2.04 5.21-4.72 5.1-7.38z"
});

var _ref180 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 321.44,
  cy: 264.12,
  fill: "url(#hero_svg__M)",
  rx: 17.52,
  ry: 10.12
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M307.36 210.78v50.77c-.47 3.08 2.07 6.29 7.64 8a21.82 21.82 0 0012.63.08c5.3-1.58 7.95-4.47 7.95-7.37v-51.48z",
  fill: "url(#hero_svg__N)",
  opacity: 0.39
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M329.32 262.44v-5.26a7.86 7.86 0 00-15.72 0V262c-.2 1.29.55 2.62 2.27 3.62a12.35 12.35 0 0011.14 0 3.93 3.93 0 002.31-3.18z",
  fill: "#8ecda1"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M335.58 262.27v-9.44a14.11 14.11 0 10-28.22 0v8.72c-.35 2.33 1 4.72 4.08 6.5 5.52 3.18 14.47 3.18 20 0 2.76-1.6 4.14-3.69 4.14-5.78z",
  fill: "none",
  stroke: "url(#hero_svg__O)",
  strokeMiterlimit: 10,
  strokeWidth: 0.91
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M366 298.75v-15.21h-35v15.21c-.1 2.67 1.59 5.35 5.12 7.39 6.84 3.95 17.94 3.95 24.78 0 3.5-2.04 5.2-4.72 5.1-7.39z"
});

var _ref185 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 348.49,
  cy: 283.54,
  fill: "url(#hero_svg__P)",
  rx: 17.52,
  ry: 10.12
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M356.37 281.86v-5.26a7.86 7.86 0 00-15.72 0v4.86c-.2 1.29.55 2.62 2.27 3.61a12.29 12.29 0 0011.14 0 3.9 3.9 0 002.31-3.21z",
  fill: "url(#hero_svg__Q)"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M362.63 281.69v-9.44a14.11 14.11 0 00-28.22 0V281c-.35 2.33 1 4.72 4.08 6.5 5.52 3.18 14.47 3.18 20 0 2.76-1.63 4.14-3.72 4.14-5.81z",
  fill: "none",
  stroke: "url(#hero_svg__R)",
  strokeMiterlimit: 10,
  strokeWidth: 0.91
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M676.5 354.46H359.8v9.87a14 14 0 007 12.58l137.73 80.82a26.93 26.93 0 0027.24 0l137.73-80.82a14 14 0 007-12.58z",
  fill: "url(#hero_svg__S)"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M669.5 366l-137.73 80.86a26.93 26.93 0 01-27.24 0L366.8 366a14.18 14.18 0 01.09-24.51L504.69 262a26.91 26.91 0 0126.92 0l137.8 79.56a14.18 14.18 0 01.09 24.44z",
  fill: "url(#hero_svg__T)"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M676.5 353.76a14 14 0 01-7 12.28l-137.73 80.82a26.93 26.93 0 01-27.24 0L366.8 366a14 14 0 01-7-11.58",
  fill: "none",
  stroke: "url(#hero_svg__U)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M377.66 405.71H61v9.87a14 14 0 007 12.58L205.69 509a26.89 26.89 0 0027.24 0l137.73-80.81a14 14 0 007-12.58z",
  fill: "url(#hero_svg__V)"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M370.66 417.05l-137.73 80.81a26.89 26.89 0 01-27.24 0L68 417.05a14.18 14.18 0 01.09-24.51L205.85 313a26.91 26.91 0 0126.92 0l137.8 79.56a14.18 14.18 0 01.09 24.49z",
  fill: "url(#hero_svg__W)"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M377.66 405a14 14 0 01-7 12.28L232.93 498.1a26.89 26.89 0 01-27.24 0L68 417.29a14.05 14.05 0 01-7-11.58",
  fill: "none",
  stroke: "url(#hero_svg__X)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M486.07 472.6H327.71v4.93c-.06 2.43 1.1 10.46 3.5 11.86l68.86 40.41a13.44 13.44 0 0013.62 0l68.86-40.41a7 7 0 003.5-6.29z",
  fill: "url(#hero_svg__Y)"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M482.56 478.39L413.7 518.8a13.49 13.49 0 01-13.62 0l-68.86-40.41a7.09 7.09 0 010-12.26l68.9-39.78a13.48 13.48 0 0113.46 0l68.9 39.78a7.09 7.09 0 01.08 12.26z",
  fill: "url(#hero_svg__Z)"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M486.07 472.25a7 7 0 01-3.51 6.14L413.7 518.8a13.49 13.49 0 01-13.62 0l-68.86-40.41a7 7 0 01-3.5-5.79",
  fill: "none",
  stroke: "url(#hero_svg__aa)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M708.59 472.6H550.24v4.93c-.06 2.43 1.09 10.46 3.49 11.86l68.87 40.41a13.44 13.44 0 0013.62 0l68.87-40.41a7 7 0 003.49-6.29z",
  fill: "url(#hero_svg__ab)"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M705.09 478.39l-68.87 40.41a13.49 13.49 0 01-13.62 0l-68.86-40.41a7.09 7.09 0 010-12.26l68.9-39.78a13.48 13.48 0 0113.46 0l68.9 39.78a7.1 7.1 0 01.09 12.26z",
  fill: "url(#hero_svg__ac)"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M708.59 472.25a7 7 0 01-3.5 6.14l-68.87 40.41a13.49 13.49 0 01-13.62 0l-68.86-40.41a7 7 0 01-3.5-5.79",
  fill: "none",
  stroke: "url(#hero_svg__ad)",
  strokeMiterlimit: 10,
  strokeWidth: 1.63
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M391.82 361.72l115.41 67.72a22.54 22.54 0 0022.83 0l115.41-67.72a11.88 11.88 0 00-.07-20.54l-115.47-66.67a22.56 22.56 0 00-22.56 0l-115.48 66.67a11.88 11.88 0 00-.07 20.54z",
  fill: "none",
  stroke: "url(#hero_svg__g)",
  strokeMiterlimit: 10,
  strokeWidth: 1.49
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M415.29 359.36l94 55.14a18.4 18.4 0 0018.59 0l94-55.14a9.69 9.69 0 00-.06-16.73l-94-54.28a18.38 18.38 0 00-18.37 0l-94 54.28a9.69 9.69 0 00-.16 16.73z",
  fill: "none",
  stroke: "url(#hero_svg__ae)",
  strokeMiterlimit: 10,
  strokeWidth: 1.22
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M608 304.29H429.2v46.22a7.94 7.94 0 004 7.1l77.74 45.62a15.22 15.22 0 0015.38 0L604 357.61a7.94 7.94 0 004-7.1z",
  fill: "url(#hero_svg__af)"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M604 310.83l-77.73 45.61a15.18 15.18 0 01-15.38 0l-77.74-45.61a8 8 0 010-13.84L511 252.08a15.21 15.21 0 0115.19 0L604 297a8 8 0 010 13.83z",
  fill: "url(#hero_svg__ag)"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M608 303.9a7.93 7.93 0 01-4 6.93l-77.73 45.61a15.18 15.18 0 01-15.38 0l-77.74-45.61a7.94 7.94 0 01-4-6.54",
  fill: "none",
  stroke: "url(#hero_svg__ah)",
  strokeMiterlimit: 10,
  strokeWidth: 0.92
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M433.16 357.61l77.74 45.62a15.22 15.22 0 0015.38 0L604 357.61",
  fill: "none",
  stroke: "url(#hero_svg__ai)",
  strokeMiterlimit: 10,
  strokeWidth: 0.92
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M440.54 347.53l-2.49-1.46v-17.59l2.49 1.47z"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M440.54 333.99l-2.49-1.47v-4.04l2.49 1.47z",
  fill: "#46484a"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M449.03 352.54l-2.48-1.47v-17.58l2.48 1.47z"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M449.03 339l-2.48-1.47v-4.04l2.48 1.47z",
  fill: "#46484a"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M457.52 357.55l-2.48-1.47V338.5l2.48 1.46z"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M457.52 344l-2.48-1.46v-4.04l2.48 1.46z",
  fill: "#46484a"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M466.02 362.56l-2.49-1.47V343.5l2.49 1.47z"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M466.02 349.01l-2.49-1.46v-4.05l2.49 1.47z",
  fill: "#b1dccb"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M474.51 367.56l-2.49-1.46v-17.59l2.49 1.47z"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M474.51 354.02l-2.49-1.47v-4.04l2.49 1.47z",
  fill: "#46484a"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M483 372.57l-2.48-1.46v-17.59l2.48 1.47z"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M483 359.03l-2.48-1.47v-4.04l2.48 1.47z",
  fill: "#46484a"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M491.5 377.58l-2.49-1.47v-17.58l2.49 1.46z"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M491.5 364.03l-2.49-1.46v-4.04l2.49 1.46z",
  fill: "#b1dccb"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M499.99 382.59l-2.49-1.47v-17.58l2.49 1.46z"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M499.99 369.04l-2.49-1.46v-4.04l2.49 1.46z",
  fill: "#46484a"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M508.48 387.59l-2.48-1.46v-17.59l2.48 1.47z"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M508.48 374.05l-2.48-1.47v-4.04l2.48 1.47zM544 362.73a.83.83 0 01.43-.73l2.9-1.71v5.3a.84.84 0 01-.42.73L544 368zm-7.66 4.52a.85.85 0 01.42-.74l2.91-1.71v5.3a.84.84 0 01-.42.73l-2.91 1.72zm-7.65 4.51a.87.87 0 01.42-.74l2.91-1.71v5.3a.87.87 0 01-.42.74l-2.91 1.71zm15.31.76a.84.84 0 01.43-.74l2.9-1.71v5.3a.84.84 0 01-.42.73l-2.91 1.72zm-7.66 4.48a.87.87 0 01.42-.74l2.91-1.71v5.3a.87.87 0 01-.42.74l-2.91 1.71z",
  fill: "#46484a"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M528.69 381.54a.87.87 0 01.42-.74l2.91-1.71v5.3a.87.87 0 01-.42.74l-2.91 1.71z",
  fill: "#b1dccb"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M553.13 356.82v5.53l45.99-27.05-5.56-2.74z",
  fill: "url(#hero_svg__aj)"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M593.56 332.56l5.56 2.74v-6.06z",
  fill: "#46484a"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M553.35 366.87v5.51l45.77-26.93-5.65-2.66z",
  fill: "url(#hero_svg__ak)"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M593.47 342.79l5.65 2.66v-6.04z",
  fill: "#46484a"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M429.2 244.21H608v46.22a7.94 7.94 0 01-4 7.1l-77.73 45.62a15.22 15.22 0 01-15.38 0l-77.74-45.62a7.94 7.94 0 01-4-7.1z",
  fill: "url(#hero_svg__al)"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M433.16 250.75l77.74 45.61a15.18 15.18 0 0015.38 0L604 250.75a8 8 0 000-13.84L526.18 192a15.21 15.21 0 00-15.18 0l-77.78 44.91a8 8 0 00-.06 13.84z",
  fill: "url(#hero_svg__am)"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M429.2 243.82a7.93 7.93 0 004 6.93l77.74 45.61a15.18 15.18 0 0015.38 0L604 250.75a7.92 7.92 0 004-6.54",
  fill: "none",
  stroke: "url(#hero_svg__an)",
  strokeMiterlimit: 10,
  strokeWidth: 0.92
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M604 297.53l-77.73 45.62a15.22 15.22 0 01-15.38 0l-77.74-45.62",
  fill: "none",
  stroke: "url(#hero_svg__ao)",
  strokeMiterlimit: 10,
  strokeWidth: 0.92
});

var _ref233 = /*#__PURE__*/React.createElement("path", {
  d: "M596.63 287.45l2.49-1.46V268.4l-2.49 1.47z"
});

var _ref234 = /*#__PURE__*/React.createElement("path", {
  d: "M596.63 273.91l2.49-1.47v-4.04l-2.49 1.47z",
  fill: "#46484a"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M588.14 292.46l2.49-1.46v-17.59l-2.49 1.47z"
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M588.14 278.92l2.49-1.47v-4.04l-2.49 1.47z",
  fill: "#46484a"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M579.65 297.47l2.48-1.47v-17.58l-2.48 1.46z"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M579.65 283.92l2.48-1.46v-4.04l-2.48 1.46z",
  fill: "#46484a"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M571.15 302.48l2.49-1.47v-17.58l-2.49 1.46z"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M571.15 288.93l2.49-1.46v-4.04l-2.49 1.46z",
  fill: "#b1dccb"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M562.66 307.48l2.49-1.46v-17.59l-2.49 1.47z"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M562.66 293.94l2.49-1.47v-4.04l-2.49 1.47z",
  fill: "#46484a"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M554.17 312.49l2.48-1.46v-17.59l-2.48 1.47z"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M554.17 298.95l2.48-1.47v-4.04l-2.48 1.47z",
  fill: "#46484a"
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  d: "M545.67 317.5l2.49-1.47v-17.58l-2.49 1.46z"
});

var _ref246 = /*#__PURE__*/React.createElement("path", {
  d: "M545.67 303.95l2.49-1.46v-4.04l-2.49 1.46z",
  fill: "#b1dccb"
});

var _ref247 = /*#__PURE__*/React.createElement("path", {
  d: "M537.18 322.51l2.49-1.47v-17.59l-2.49 1.47z"
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "M537.18 308.96l2.49-1.46v-4.05l-2.49 1.47z",
  fill: "#46484a"
});

var _ref249 = /*#__PURE__*/React.createElement("path", {
  d: "M528.69 327.51l2.49-1.46v-17.59l-2.49 1.47z"
});

var _ref250 = /*#__PURE__*/React.createElement("path", {
  d: "M528.69 313.97l2.49-1.47v-4.04l-2.49 1.47z",
  fill: "#46484a"
});

var _ref251 = /*#__PURE__*/React.createElement("path", {
  d: "M308.15 295.71c-.07 9.07-30.28 8.84-30.21-.24l.05-6.69 30.21.23z"
});

var _ref252 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.1,
  cy: 288.9,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 293.085 288.892)"
});

var _ref253 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 292.84,
  cy: 278.39,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 292.823 278.383)"
});

var _ref254 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 292.95,
  cy: 283.98,
  fill: "url(#hero_svg__ap)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 292.945 283.984)"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  d: "M248.4 334.27c-.07 9.08-30.28 8.84-30.21-.23l.05-6.7 30.21.24z"
});

var _ref256 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.35,
  cy: 327.46,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 233.337 327.455)"
});

var _ref257 = /*#__PURE__*/React.createElement("path", {
  d: "M245.3 317.05c0-3.31-5.42-7-12.17-7s-12.23 3.52-12.26 6.83 5.43 6 12.17 6.08 12.24-2.61 12.26-5.91z",
  fill: "#3a404c"
});

var _ref258 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 233.21,
  cy: 322.55,
  fill: "url(#hero_svg__aq)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 233.193 322.551)"
});

var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "M222.31 327.46h22.08a65.72 65.72 0 017.26-30.13 53.71 53.71 0 0113.27-16.88 25.05 25.05 0 019.41-5.23 9.25 9.25 0 012.36-.33 3.85 3.85 0 011.83.47 3.31 3.31 0 01.81.81 8.91 8.91 0 011.21 2.28 30.29 30.29 0 011.52 10.45h22.08a51.75 51.75 0 00-3-18.39 31.36 31.36 0 00-4.3-7.79 25.85 25.85 0 00-6-5.67 24.56 24.56 0 00-10.5-4 21.48 21.48 0 00-2.64-.23h-.88s-.7 0-2.1.07a33.78 33.78 0 00-5.86.94 47.14 47.14 0 00-18 9.54A75.89 75.89 0 00232 287.18a87.81 87.81 0 00-9.73 40.28z",
  fill: "url(#hero_svg__ar)"
});

var _ref260 = /*#__PURE__*/React.createElement("path", {
  d: "M221 326.43l-.1-9.63c0 3.3 5.43 6 12.2 6.08s12.24-2.6 12.26-5.9l.1 9.64c-.08 7.38-24.55 7.16-24.46-.19zm59.72-38.56l-.1-9.64c0 3.3 5.43 6 12.2 6.09s12.24-2.6 12.26-5.9l.1 9.63c-.05 7.35-24.52 7.16-24.46-.18z"
});

var _ref261 = /*#__PURE__*/React.createElement("path", {
  d: "M104.08 419.12l145-83.69a11.32 11.32 0 0111.26 0l75.78 43.13a3 3 0 010 5.23L189.4 467.36a13 13 0 01-12.9 0l-72.4-41.88a3.64 3.64 0 01-.02-6.36z",
  fill: "url(#hero_svg__as)"
});

var _ref262 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M260.89 355.11V194.22l-138.37 80.79v161.12l9.87 5.62 128.5-74.63z",
  fill: "url(#hero_svg__at)",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M137 332.23v-2.69a4.55 4.55 0 011.92-2.35l25.15-14.69c.39-.23.63-.22.63 0v2.69a4.59 4.59 0 01-1.93 2.35l-25.15 14.69c-.39.26-.62.25-.62 0z",
  fill: "url(#hero_svg__i)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.66 303.4l45.15-26.54c.4-.23.64-.22.64 0v2.69a4.49 4.49 0 01-1.93 2.35l-45.16 26.54c-.39.23-.63.21-.63 0v-2.69a4.51 4.51 0 011.93-2.35z",
  fill: "url(#hero_svg__au)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.06 321v-2.68A4.54 4.54 0 01139 316l36.13-21.12c.4-.23.64-.22.64 0v2.68a4.59 4.59 0 01-1.93 2.35l-36.14 21.15c-.4.23-.64.21-.64-.06z",
  fill: "url(#hero_svg__av)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.77 290.8v-2.68a4.54 4.54 0 011.93-2.35l42-24.54c.4-.24.64-.22.64 0v2.69a4.48 4.48 0 01-1.93 2.34l-42 24.55c-.41.26-.64.24-.64-.01z",
  fill: "url(#hero_svg__aw)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.21 264.79v2.68a4.59 4.59 0 01-1.93 2.35l-27.78 16.23c-.39.23-.63.22-.63 0v-2.69a4.55 4.55 0 011.93-2.36l27.78-16.23c.42-.25.64-.24.63.02z",
  fill: "url(#hero_svg__ax)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.14 309.82v-2.69a4.63 4.63 0 011.93-2.35l25.15-14.69c.39-.23.63-.22.63 0v2.69a4.53 4.53 0 01-1.93 2.35l-25.14 14.69c-.4.26-.65.25-.64 0z",
  fill: "url(#hero_svg__ay)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.21 298.61v-2.69a4.48 4.48 0 011.93-2.34l36.77-21.5c.4-.23.64-.22.64 0v2.68a4.49 4.49 0 01-1.93 2.35l-36.77 21.49c-.4.27-.64.26-.64.01z",
  fill: "url(#hero_svg__az)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.57 268v-2.68a4.59 4.59 0 011.93-2.35l35.54-20.77c.39-.23.63-.21.63 0v2.68a4.49 4.49 0 01-1.93 2.35l-35.54 20.82c-.39.23-.63.21-.63-.05z",
  fill: "url(#hero_svg__aA)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.28 287.4v-2.68a4.59 4.59 0 011.93-2.35l25.14-14.69c.4-.24.64-.22.64 0v2.69a4.48 4.48 0 01-1.93 2.34l-25.14 14.7c-.4.26-.64.25-.64-.01z",
  fill: "url(#hero_svg__aB)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M178 263.61v-2.69a4.59 4.59 0 011.93-2.35l39.41-23c.4-.23.64-.22.64 0v2.69a4.58 4.58 0 01-1.93 2.35l-39.41 23c-.39.26-.64.25-.64 0z",
  fill: "url(#hero_svg__aC)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.06 374.58v-2.69a4.54 4.54 0 011.93-2.35l36.13-21.11c.4-.24.64-.22.64 0v2.69a4.57 4.57 0 01-1.93 2.34l-36.13 21.15c-.4.23-.64.22-.64-.03z",
  fill: "url(#hero_svg__aD)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.21 363.26v-2.68a4.49 4.49 0 011.93-2.35l36.77-21.49c.4-.23.64-.22.64 0v2.69a4.48 4.48 0 01-1.93 2.34l-36.77 21.5c-.4.26-.64.25-.64-.01z",
  fill: "url(#hero_svg__aE)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.57 332.67V330a4.63 4.63 0 011.93-2.35l35.54-20.76c.39-.23.63-.22.63 0v2.69a4.53 4.53 0 01-1.93 2.35L190.2 332.7c-.39.23-.63.22-.63-.03z",
  fill: "url(#hero_svg__aF)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.28 352.06v-2.69a4.63 4.63 0 011.93-2.35l25.14-14.69c.4-.23.64-.22.64 0v2.69a4.53 4.53 0 01-1.93 2.35l-25.14 14.69c-.4.26-.64.25-.64 0z",
  fill: "url(#hero_svg__aG)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M178 328.26v-2.69a4.57 4.57 0 011.93-2.34l39.41-23c.4-.23.64-.21.64 0v2.69a4.56 4.56 0 01-1.93 2.34l-39.41 23c-.39.26-.64.25-.64 0z",
  fill: "url(#hero_svg__aH)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M141 295.13c20.77-7.23 16.29 40 27.76 47 9 5.48 18-2.08 24.13 1.78 15.18 9.54 15.42 38.94 30.54 29.37 12.56-7.95 20-25.6 35.1-34.75 26.08-15.82 39 6.67 39 6.67v28.67l-137.74 83.19L141 446.35z",
  fill: "url(#hero_svg__aI)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.59 318.32c22.22-13.1 14.83 105.31 33.81 92.75 13.82-9.14 13-19.29 23.19-29.71 11.62-11.91 19.64 9.56 38.31-1.7 16.65-10 18.89-19.09 34.13-28.79 17.39-11.06 27.05 1.94 27.05 1.94v42L189.4 467.36c-4.31 2.16-8.14 2.1-11 .57L161.19 458z",
  fill: "url(#hero_svg__aJ)"
}));

var _ref263 = /*#__PURE__*/React.createElement("path", {
  d: "M409.71 282.62l.43 68.35a9.59 9.59 0 004.86 8.32l94.41 55.95a18.37 18.37 0 0018.57-.19l93.25-54.17a9.59 9.59 0 004.69-8.42l-.44-72.09z",
  fill: "url(#hero_svg__aK)",
  opacity: 0.25
});

var _ref264 = /*#__PURE__*/React.createElement("path", {
  d: "M385 262.71l.53 88.71a11.77 11.77 0 006 10.21l116 68.72a22.53 22.53 0 0022.8-.23l114.54-66.54a11.74 11.74 0 005.75-10.34l-.62-90.53z",
  fill: "url(#hero_svg__aL)",
  opacity: 0.25
});

var _ref265 = /*#__PURE__*/React.createElement("path", {
  d: "M338.94 314.54v-15.22h-35v15.22c-.1 2.66 1.59 5.34 5.12 7.38 6.84 3.95 17.94 3.95 24.78 0 3.51-2.04 5.21-4.72 5.1-7.38z"
});

var _ref266 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 321.44,
  cy: 299.32,
  fill: "url(#hero_svg__aM)",
  rx: 17.52,
  ry: 10.12
});

var _ref267 = /*#__PURE__*/React.createElement("path", {
  d: "M329.32 297.64v-5.26a7.86 7.86 0 00-15.72 0v4.86c-.2 1.29.55 2.62 2.27 3.62a12.35 12.35 0 0011.14 0 3.93 3.93 0 002.31-3.22z",
  fill: "url(#hero_svg__aN)"
});

var _ref268 = /*#__PURE__*/React.createElement("path", {
  d: "M335.58 297.47V288a14.11 14.11 0 00-28.22 0v8.72c-.35 2.33 1 4.72 4.08 6.5 5.52 3.18 14.47 3.18 20 0 2.76-1.57 4.14-3.66 4.14-5.75z",
  fill: "none",
  stroke: "url(#hero_svg__aO)",
  strokeMiterlimit: 10,
  strokeWidth: 0.91
});

var _ref269 = /*#__PURE__*/React.createElement("path", {
  d: "M571.53 519.37a23.19 23.19 0 00-11.68-20.13l-11.35-6.48c-5.13-3-9.29-10.92-9.29-17.76 0-6.85 4.16-10 9.29-7l11.35 6.48a23.19 23.19 0 0111.68 20.12v24.8z",
  opacity: 0.5,
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref270 = /*#__PURE__*/React.createElement("path", {
  d: "M467.63 519.37a23.19 23.19 0 0111.68-20.13l11.34-6.48c5.14-3 9.3-10.92 9.3-17.76 0-6.85-4.16-10-9.3-7l-11.34 6.48a23.19 23.19 0 00-11.68 20.12v24.8z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref271 = /*#__PURE__*/React.createElement("path", {
  d: "M547.21 551.87c0 16-53.28 16-53.28 0v-20.72h53.28z"
});

var _ref272 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 520.57,
  cy: 535.11,
  fill: "url(#hero_svg__aP)",
  rx: 26.64,
  ry: 13.07
});

var _ref273 = /*#__PURE__*/React.createElement("path", {
  d: "M552.26 546.59c0 19-63.38 19-63.38 0v-24.66h63.38z",
  fill: "url(#hero_svg__aQ)"
});

var _ref274 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 520.57,
  cy: 521.93,
  fill: "url(#hero_svg__aR)",
  rx: 31.69,
  ry: 15.54
});

var _ref275 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 520.57,
  cy: 521.19,
  fill: "url(#hero_svg__aS)",
  rx: 21.97,
  ry: 7.83
});

var _ref276 = /*#__PURE__*/React.createElement("path", {
  d: "M495.85 519.73c0 15 49.9 15 49.9 0v-67.92h-49.9z",
  fill: "url(#hero_svg__aT)",
  opacity: 0.17
});

var _ref277 = /*#__PURE__*/React.createElement("path", {
  d: "M521.3 483.53l13.08 7.47a3.43 3.43 0 011.74 3l-.12 15.07a1.37 1.37 0 01-.68 1.17l-14.15 8.18-15.47-26.73 14.24-8.16a1.37 1.37 0 011.36 0z",
  fill: "url(#hero_svg__l)"
});

var _ref278 = /*#__PURE__*/React.createElement("path", {
  d: "M506.62 491.74l13.27 7.57a3.48 3.48 0 011.75 3.05l-.13 15.26a1.06 1.06 0 01-1.59.91l-13.17-7.63a3.51 3.51 0 01-1.73-3v-15.22a1.06 1.06 0 011.6-.94z",
  fill: "url(#hero_svg__m)"
});

var _ref279 = /*#__PURE__*/React.createElement("path", {
  d: "M495.85 519.73c0 15 49.9 15 49.9 0v-52.9h-49.9z",
  fill: "url(#hero_svg__aU)",
  opacity: 0.52
});

var _ref280 = /*#__PURE__*/React.createElement("path", {
  d: "M493 521.44c0 16.71 55.66 16.71 55.66 0v-62.9H493z",
  fill: "url(#hero_svg__aV)",
  opacity: 0.52
});

var _ref281 = /*#__PURE__*/React.createElement("path", {
  d: "M552.26 465.74c0 19-63.38 19-63.38 0v-14.05h63.38z",
  fill: "url(#hero_svg__aW)"
});

var _ref282 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 520.57,
  cy: 451.69,
  fill: "url(#hero_svg__aX)",
  rx: 31.69,
  ry: 15.54
});

var _ref283 = /*#__PURE__*/React.createElement("path", {
  d: "M571.53 493.68a23.17 23.17 0 01-11.68 20.12l-11.35 6.49c-5.13 3-9.29 10.92-9.29 17.76 0 6.85 4.16 10 9.29 7l11.35-6.48a23.19 23.19 0 0011.68-20.13z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref284 = /*#__PURE__*/React.createElement("path", {
  d: "M467.63 493.68a23.17 23.17 0 0011.68 20.12l11.34 6.49c5.14 3 9.3 10.92 9.3 17.76 0 6.85-4.16 10-9.3 7l-11.34-6.48a23.19 23.19 0 01-11.68-20.13zm109.68-38.48A23.19 23.19 0 01589 435.08l11.35-6.48c5.13-3 9.29-10.91 9.29-17.76 0-6.84-4.16-10-9.29-7L589 410.29a23.18 23.18 0 00-11.68 20.12v24.79z",
  opacity: 0.5,
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref285 = /*#__PURE__*/React.createElement("path", {
  d: "M681.21 455.2a23.17 23.17 0 00-11.68-20.12l-11.34-6.48c-5.14-3-9.3-10.91-9.3-17.76 0-6.84 4.16-10 9.3-7l11.34 6.48a23.16 23.16 0 0111.68 20.12z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref286 = /*#__PURE__*/React.createElement("path", {
  d: "M656.89 487.71c0 16-53.28 16-53.28 0V467h53.28z"
});

var _ref287 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 630.25,
  cy: 470.95,
  fill: "url(#hero_svg__aY)",
  rx: 26.64,
  ry: 13.07
});

var _ref288 = /*#__PURE__*/React.createElement("path", {
  d: "M662 482.43c0 19-63.39 19-63.39 0v-24.66H662z",
  fill: "url(#hero_svg__aZ)"
});

var _ref289 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 630.25,
  cy: 457.77,
  fill: "url(#hero_svg__ba)",
  rx: 31.69,
  ry: 15.54
});

var _ref290 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 630.25,
  cy: 457.03,
  fill: "url(#hero_svg__bb)",
  rx: 21.97,
  ry: 7.83
});

var _ref291 = /*#__PURE__*/React.createElement("path", {
  d: "M605.53 455.57c0 15 49.9 15 49.9 0v-67.93h-49.9z",
  fill: "url(#hero_svg__bc)",
  opacity: 0.17
});

var _ref292 = /*#__PURE__*/React.createElement("path", {
  d: "M629.75 418l-13.08 7.45a3.45 3.45 0 00-1.74 3l.13 15.05a1.37 1.37 0 00.68 1.18l14.15 8.17 15.46-26.73-14.24-8.12a1.37 1.37 0 00-1.36 0z",
  fill: "url(#hero_svg__bd)"
});

var _ref293 = /*#__PURE__*/React.createElement("path", {
  d: "M644.42 426.23l-13.26 7.56a3.49 3.49 0 00-1.75 3l.13 15.27a1.06 1.06 0 001.59.9l13.17-7.63a3.48 3.48 0 001.73-3v-15.22a1.06 1.06 0 00-1.61-.88z",
  fill: "url(#hero_svg__be)"
});

var _ref294 = /*#__PURE__*/React.createElement("path", {
  d: "M605.53 455.57c0 15 49.9 15 49.9 0v-52.9h-49.9z",
  fill: "url(#hero_svg__bf)",
  opacity: 0.52
});

var _ref295 = /*#__PURE__*/React.createElement("path", {
  d: "M602.65 457.27c0 16.72 55.66 16.72 55.66 0v-62.89h-55.66z",
  fill: "url(#hero_svg__bg)",
  opacity: 0.52
});

var _ref296 = /*#__PURE__*/React.createElement("path", {
  d: "M662 401.58c0 19-63.39 19-63.39 0v-14.05H662z",
  fill: "url(#hero_svg__bh)"
});

var _ref297 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 630.25,
  cy: 387.53,
  fill: "url(#hero_svg__bi)",
  rx: 31.69,
  ry: 15.54
});

var _ref298 = /*#__PURE__*/React.createElement("path", {
  d: "M577.31 429.52A23.17 23.17 0 00589 449.64l11.35 6.48c5.13 3 9.29 10.92 9.29 17.76 0 6.85-4.16 10-9.29 7L589 474.43a23.17 23.17 0 01-11.68-20.12v-24.79z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref299 = /*#__PURE__*/React.createElement("path", {
  d: "M681.21 429.52a23.14 23.14 0 01-11.68 20.12l-11.34 6.48c-5.14 3-9.3 10.92-9.3 17.76 0 6.85 4.16 10 9.3 7l11.34-6.49a23.14 23.14 0 0011.68-20.12zM352.7 455.2a23.17 23.17 0 0111.68-20.12l11.34-6.48c5.14-3 9.3-10.91 9.3-17.76 0-6.84-4.16-10-9.3-7l-11.34 6.48a23.16 23.16 0 00-11.68 20.12z",
  opacity: 0.5,
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref300 = /*#__PURE__*/React.createElement("path", {
  d: "M456.6 455.2a23.19 23.19 0 00-11.68-20.12l-11.35-6.48c-5.13-3-9.29-10.91-9.29-17.76 0-6.84 4.16-10 9.29-7l11.35 6.48a23.18 23.18 0 0111.68 20.12z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref301 = /*#__PURE__*/React.createElement("path", {
  d: "M432.28 487.71c0 16-53.28 16-53.28 0V467h53.28z"
});

var _ref302 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 405.64,
  cy: 470.95,
  fill: "url(#hero_svg__bj)",
  rx: 26.64,
  ry: 13.07
});

var _ref303 = /*#__PURE__*/React.createElement("path", {
  d: "M437.33 482.43c0 19-63.38 19-63.38 0v-24.66h63.38z",
  fill: "url(#hero_svg__bk)"
});

var _ref304 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 405.64,
  cy: 457.77,
  fill: "url(#hero_svg__bl)",
  rx: 31.69,
  ry: 15.54
});

var _ref305 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 405.64,
  cy: 457.03,
  fill: "url(#hero_svg__bm)",
  rx: 21.97,
  ry: 7.83
});

var _ref306 = /*#__PURE__*/React.createElement("path", {
  d: "M380.92 455.57c0 15 49.89 15 49.89 0v-67.93h-49.89z",
  fill: "url(#hero_svg__bn)",
  opacity: 0.17
});

var _ref307 = /*#__PURE__*/React.createElement("path", {
  d: "M391.1 444.7l13 7.66a3.48 3.48 0 003.5 0l13-7.58a1.4 1.4 0 00.69-1.18l.08-16.34-30.88-.17v16.42a1.39 1.39 0 00.61 1.19z",
  fill: "url(#hero_svg__bo)"
});

var _ref308 = /*#__PURE__*/React.createElement("path", {
  d: "M391 427.88l13.14 7.77a3.49 3.49 0 003.52 0l13.15-7.65a1.06 1.06 0 000-1.83l-13.16-7.65a3.47 3.47 0 00-3.47 0L391 426.05a1.06 1.06 0 000 1.83z",
  fill: "url(#hero_svg__bp)"
});

var _ref309 = /*#__PURE__*/React.createElement("path", {
  d: "M380.92 455.57c0 15 49.89 15 49.89 0v-52.9h-49.89z",
  fill: "url(#hero_svg__bq)",
  opacity: 0.52
});

var _ref310 = /*#__PURE__*/React.createElement("path", {
  d: "M378 457.27c0 16.72 55.66 16.72 55.66 0v-62.89H378z",
  fill: "url(#hero_svg__br)",
  opacity: 0.52
});

var _ref311 = /*#__PURE__*/React.createElement("path", {
  d: "M437.33 401.58c0 19-63.38 19-63.38 0v-14.05h63.38z",
  fill: "url(#hero_svg__bs)"
});

var _ref312 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 405.64,
  cy: 387.53,
  fill: "url(#hero_svg__bt)",
  rx: 31.69,
  ry: 15.54
});

var _ref313 = /*#__PURE__*/React.createElement("path", {
  d: "M352.7 429.52a23.14 23.14 0 0011.68 20.12l11.34 6.48c5.14 3 9.3 10.92 9.3 17.76 0 6.85-4.16 10-9.3 7l-11.34-6.49a23.14 23.14 0 01-11.68-20.12z",
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref314 = /*#__PURE__*/React.createElement("path", {
  d: "M456.6 429.52a23.17 23.17 0 01-11.68 20.12l-11.35 6.48c-5.13 3-9.29 10.92-9.29 17.76 0 6.85 4.16 10 9.29 7l11.35-6.49a23.17 23.17 0 0011.68-20.12z",
  opacity: 0.5,
  fill: "none",
  stroke: "#00c680",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.93
});

var _ref315 = /*#__PURE__*/React.createElement("path", {
  d: "M512.58 230.28c-.07 9.08-30.28 8.85-30.21-.23l.05-6.69 30.21.23z"
});

var _ref316 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 497.53,
  cy: 223.47,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 497.512 223.478)"
});

var _ref317 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 497.27,
  cy: 212.96,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 497.251 212.969)"
});

var _ref318 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 497.38,
  cy: 218.56,
  fill: "url(#hero_svg__bu)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 497.368 218.565)"
});

var _ref319 = /*#__PURE__*/React.createElement("path", {
  d: "M486.6 221.91l5.46.78 2.74.39 1.36.2 1.37.19 2.73.39 1.37.2 1.36.19 1.37.2 1.36.19 1.37.2 1.37.19c.11-1 .19-1.89.25-2.65s0-1.35.05-1.84v-1.47a41 41 0 00-2.55-12.44 45.31 45.31 0 00-5.78-10.85 37.12 37.12 0 00-9.32-9.16 29.39 29.39 0 00-3.1-1.83l-1.66-.82c-.57-.25-1.19-.47-1.79-.69a26.65 26.65 0 00-7.83-1.58h-.93c-.62 0-1.57 0-2.8.14a27.22 27.22 0 00-10.14 3.31 36.88 36.88 0 00-11.05 9.92 70.21 70.21 0 00-8.57 15.19l1.27.54 1.27.54 1.27.53 1.27.54 1.27.54 1.27.54 2.55 1.08 1.27.53 1.27.54 2.54 1.08 5.08 2.15a48.62 48.62 0 015.75-10.35 15.14 15.14 0 014.35-4.12 5.38 5.38 0 011.72-.61 1.25 1.25 0 00.45 0 6.56 6.56 0 012.93 1.16 15.56 15.56 0 013.8 3.84 21.85 21.85 0 014.13 11.15v1.18s-.09.48-.1.79z",
  fill: "url(#hero_svg__bv)"
});

var _ref320 = /*#__PURE__*/React.createElement("path", {
  d: "M485.15 222.44l-.1-9.63c0 3.3 5.43 6 12.2 6.08s12.24-2.59 12.26-5.9l.1 9.64c-.05 7.37-24.52 7.16-24.46-.19zm44.85 6.89c.08 9.07 30.28 8.84 30.21-.23l-.05-6.7-30.21.24z"
});

var _ref321 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 545.04,
  cy: 222.52,
  fill: "#303234",
  rx: 15.11,
  ry: 7.41,
  transform: "rotate(-.44 548.666 223.48)"
});

var _ref322 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 545.3,
  cy: 212.01,
  fill: "#3a404c",
  rx: 12.22,
  ry: 5.99,
  transform: "rotate(-.44 548.706 213.062)"
});

var _ref323 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 545.18,
  cy: 217.61,
  fill: "url(#hero_svg__bw)",
  rx: 12.19,
  ry: 5.98,
  transform: "rotate(-.44 548.686 218.27)"
});

var _ref324 = /*#__PURE__*/React.createElement("path", {
  d: "M534.11 224.08l1.36-.2 1.37-.19 1.37-.2 1.36-.19 1.37-.2 1.37-.19 2.73-.39 1.36-.2 1.37-.19 2.73-.39 5.5-.74c0-.38-.07-.71-.1-1s0-.56 0-.76v-.62a26.85 26.85 0 013.45-12.48 14 14 0 013.25-4c.25-.26.46-.29.65-.47s.17-.06.25-.11.15-.1.2-.09a.25.25 0 00.14-.06h.15c.06 0 0 .07.17 0a.34.34 0 00.16.07h.1l.16.09c.12.07.23.08.4.16a3.93 3.93 0 00.61.36 19.28 19.28 0 014.2 4.17 57.17 57.17 0 015.78 9.5l5-2.44 2.47-1.22 1.24-.61 1.24-.61 2.47-1.22 1.24-.61 1.24-.61 1.24-.61 1.24-.61 1.23-.61 1.24-.61a77.31 77.31 0 00-8.22-13.37 40.29 40.29 0 00-9.56-9.07c-.88-.54-1.72-1-2.51-1.46s-1.69-.77-2.44-1.09c-.39-.15-.75-.31-1.12-.43l-1.11-.32c-.71-.2-1.35-.36-1.93-.5-1.18-.22-2.12-.29-2.72-.36l-.92-.08c-.76 0-1.53 0-2.29.06-.38 0-.77 0-1.14.07l-1.12.18c-.74.14-1.5.27-2.22.46s-1.4.44-2.09.68a14.42 14.42 0 00-2 .83c-.62.3-1.27.61-1.85.95a26.51 26.51 0 00-3.23 2.2 35.49 35.49 0 00-8.78 10.25 48.37 48.37 0 00-4.68 11.26 47.07 47.07 0 00-1.75 12.17v1.38c0 .47 0 1 .08 1.74z",
  fill: "url(#hero_svg__bx)"
});

var _ref325 = /*#__PURE__*/React.createElement("path", {
  d: "M557.42 221.49l.1-9.64c0 3.31-5.44 6-12.2 6.09s-12.24-2.6-12.27-5.9l-.09 9.63c.04 7.33 24.51 7.17 24.46-.18zM520.1 452.28c-.07 9.08-30.28 8.84-30.21-.23l.05-6.7 30.21.24z"
});

var _ref326 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 505.05,
  cy: 445.47,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 505.025 445.47)"
});

var _ref327 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 504.78,
  cy: 434.96,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 504.764 434.96)"
});

var _ref328 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 504.9,
  cy: 440.56,
  fill: "url(#hero_svg__by)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 504.876 440.562)"
});

var _ref329 = /*#__PURE__*/React.createElement("path", {
  d: "M436.42 389.08c-.07 9.08-30.28 8.85-30.21-.23l.05-6.69 30.21.23z"
});

var _ref330 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.36,
  cy: 382.27,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 421.346 382.272)"
});

var _ref331 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.1,
  cy: 371.76,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 421.085 371.762)"
});

var _ref332 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 421.22,
  cy: 377.36,
  fill: "url(#hero_svg__bz)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 421.202 377.358)"
});

var _ref333 = /*#__PURE__*/React.createElement("path", {
  d: "M410.32 382.27h22.08c0-5.15.75-9.26 1.81-11.66a10.46 10.46 0 011.48-2.61 5.35 5.35 0 011.24-1.08 5.74 5.74 0 012.25-.75c.67-.09 1.09-.09 1.07-.1a22.84 22.84 0 019.22 2.21 52.34 52.34 0 0110.17 6 85.53 85.53 0 0117.7 18.07c10.15 13.81 16.54 30.45 16.82 46.92v1.37c0 .91 0 2.28-.12 4.1l5.51.36 2.75.18 1.38.09 1.38.09 2.75.18 1.38.09 1.37.09 1.38.09 1.38.09 1.37.09 1.38.09c.12-2.42.19-4.24.17-5.46v-1.82a97.34 97.34 0 00-6.06-31.68 113 113 0 00-15-27.93 107.51 107.51 0 00-22.38-22.77 74.23 74.23 0 00-14.57-8.52 44.09 44.09 0 00-18.58-4l-.88.05a23.13 23.13 0 00-2.66.26 28 28 0 00-4.55 1 24.78 24.78 0 00-2.94 1.1c-.52.24-1.06.48-1.61.75s-1.1.62-1.66 1a27.46 27.46 0 00-6.6 5.72 32.41 32.41 0 00-4.94 8.32c-2.57 6.12-3.43 12.9-3.49 20.07z",
  fill: "url(#hero_svg__bA)"
});

var _ref334 = /*#__PURE__*/React.createElement("path", {
  d: "M409 381.24l-.1-9.63c0 3.3 5.44 6 12.2 6.08s12.25-2.59 12.27-5.9l.09 9.64c-.07 7.34-24.53 7.16-24.46-.19zm83.66 63.2l-.09-9.63c0 3.3 5.43 6 12.19 6.08S517 438.29 517 435l.1 9.64c-.03 7.36-24.49 7.15-24.44-.2zm28.2 7.84c.07 9.08 30.28 8.84 30.21-.23l-.06-6.7-30.2.24z"
});

var _ref335 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 535.91,
  cy: 445.47,
  fill: "#303234",
  rx: 15.11,
  ry: 7.41,
  transform: "rotate(-.44 538.686 448.72)"
});

var _ref336 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 536.17,
  cy: 434.96,
  fill: "#3a404c",
  rx: 12.22,
  ry: 5.99,
  transform: "rotate(-.44 538.73 437)"
});

var _ref337 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 536.05,
  cy: 440.56,
  fill: "url(#hero_svg__bB)",
  rx: 12.19,
  ry: 5.98,
  transform: "rotate(-.44 538.706 443.511)"
});

var _ref338 = /*#__PURE__*/React.createElement("path", {
  d: "M600.83 389.08c.07 9.08 30.28 8.85 30.21-.23l-.06-6.69-30.21.23z"
});

var _ref339 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 615.88,
  cy: 382.27,
  fill: "#303234",
  rx: 15.11,
  ry: 7.41,
  transform: "rotate(-.44 619.67 383.921)"
});

var _ref340 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 616.14,
  cy: 371.76,
  fill: "#3a404c",
  rx: 12.22,
  ry: 5.99,
  transform: "rotate(-.44 619.71 373.504)"
});

var _ref341 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 616.02,
  cy: 377.36,
  fill: "url(#hero_svg__bC)",
  rx: 12.19,
  ry: 5.98,
  transform: "rotate(-.44 619.685 380.015)"
});

var _ref342 = /*#__PURE__*/React.createElement("path", {
  d: "M604.84 382.27h22.08c0-7-.85-13.62-3.19-19.66a32.56 32.56 0 00-4.59-8.26 27.58 27.58 0 00-6.34-5.92 26.4 26.4 0 00-6.2-3 27.05 27.05 0 00-4.61-1.09 25.28 25.28 0 00-2.7-.28l-.89-.05a36.2 36.2 0 00-10 1.19 48.63 48.63 0 00-8.52 3.07 72.55 72.55 0 00-14.14 8.79 105.83 105.83 0 00-21.37 23 114.19 114.19 0 00-14.1 27.77 100.61 100.61 0 00-5.54 31.1v1.81c0 1.21.06 3 .18 5.43l1.38-.09 1.38-.09 1.38-.09 1.37-.09 1.38-.09 1.38-.09 2.75-.18 1.38-.09 1.37-.09 2.76-.18 5.51-.36c-.09-1.83-.15-3.21-.14-4.13v-1.38a78.66 78.66 0 014.32-24.22 92.39 92.39 0 0111.38-22.38 84.24 84.24 0 0116.84-18.22 50.26 50.26 0 019.75-6.11 20.61 20.61 0 018.67-2.24 6.15 6.15 0 012.82.76 6 6 0 011.12 1.06 10.55 10.55 0 011.42 2.69 22.21 22.21 0 011.23 4.85 50.43 50.43 0 01.48 6.86z",
  fill: "url(#hero_svg__bD)"
});

var _ref343 = /*#__PURE__*/React.createElement("path", {
  d: "M628.26 381.24l.1-9.63c0 3.3-5.43 6-12.2 6.08s-12.24-2.59-12.26-5.9l-.1 9.64c.05 7.34 24.51 7.16 24.46-.19zm-79.97 63.2l.1-9.63c0 3.3-5.43 6-12.2 6.08s-12.24-2.6-12.26-5.9l-.1 9.64c.05 7.37 24.52 7.16 24.46-.19zm-142.67-55.59c-.07 9.07-30.28 8.84-30.21-.24v-6.69l30.21.23z"
});

var _ref344 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 390.56,
  cy: 382.03,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 390.547 382.039)"
});

var _ref345 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 390.3,
  cy: 371.53,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 390.285 371.53)"
});

var _ref346 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 390.42,
  cy: 377.12,
  fill: "url(#hero_svg__bE)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 390.402 377.125)"
});

var _ref347 = /*#__PURE__*/React.createElement("path", {
  d: "M333.09 423.78c-.07 9.07-30.28 8.84-30.21-.24l.05-6.69 30.21.23z"
});

var _ref348 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 318.03,
  cy: 416.97,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 318.016 416.966)"
});

var _ref349 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 317.77,
  cy: 406.46,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 317.754 406.456)"
});

var _ref350 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 317.89,
  cy: 412.05,
  fill: "url(#hero_svg__bF)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 317.871 412.052)"
});

var _ref351 = /*#__PURE__*/React.createElement("path", {
  d: "M307 417h22.08a69 69 0 019.18-34.13 63.23 63.23 0 0116.33-18.91 33.69 33.69 0 0111.82-6.05c.63-.17 1.15-.23 1.6-.33l1.07-.13.8-.05a7.77 7.77 0 014.11.88 7.49 7.49 0 011.46 1.16 12.55 12.55 0 011.41 2 22.58 22.58 0 012.13 6.38 47.6 47.6 0 01.73 8.25v1.31c0 .87-.05 2.2-.14 4l5.51.36 2.75.18 1.38.09 1.37.09 2.76.19 1.37.09 1.38.09 1.38.09 1.38.09 1.37.09 1.38.09c.12-2.28.2-4 .19-5.16v-1.74a69.49 69.49 0 00-1.12-12.21 44.3 44.3 0 00-4.53-13 34.61 34.61 0 00-4.6-6.35 29.43 29.43 0 00-6.57-5.2 27.59 27.59 0 00-7.82-3 32.86 32.86 0 00-7.85-.77l-2.15.13c-.71.06-1.57.18-2.61.32s-2.2.38-3.48.72a55.54 55.54 0 00-19.74 9.82 84.89 84.89 0 00-22.22 25.58 92.51 92.51 0 00-8.53 20.1A89.46 89.46 0 00307 417z",
  fill: "url(#hero_svg__bG)"
});

var _ref352 = /*#__PURE__*/React.createElement("path", {
  d: "M305.65 415.94l-.09-9.64c0 3.3 5.43 6 12.19 6.09s12.25-2.6 12.27-5.9l.1 9.63c-.06 7.35-24.52 7.16-24.47-.18zM378.18 381l-.1-9.63c0 3.3 5.44 6 12.2 6.09s12.24-2.6 12.27-5.9l.09 9.63c-.05 7.35-24.51 7.16-24.46-.19zM661 388.85c-.07 9.07-30.28 8.84-30.21-.24v-6.69l30.21.23z"
});

var _ref353 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 645.91,
  cy: 382.03,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 645.89 382.042)"
});

var _ref354 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 645.65,
  cy: 371.53,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 645.63 371.533)"
});

var _ref355 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 645.77,
  cy: 377.12,
  fill: "url(#hero_svg__bH)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 645.746 377.129)"
});

var _ref356 = /*#__PURE__*/React.createElement("path", {
  d: "M556.55 253.7c-.07 9.07-30.28 8.84-30.21-.23v-6.7l30.21.24z"
});

var _ref357 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 541.5,
  cy: 246.89,
  fill: "#303234",
  rx: 7.41,
  ry: 15.11,
  transform: "rotate(-89.56 541.476 246.896)"
});

var _ref358 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 541.24,
  cy: 236.38,
  fill: "#3a404c",
  rx: 5.99,
  ry: 12.22,
  transform: "rotate(-89.56 541.215 236.386)"
});

var _ref359 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 541.35,
  cy: 241.98,
  fill: "url(#hero_svg__bI)",
  rx: 5.98,
  ry: 12.19,
  transform: "rotate(-89.56 541.332 241.982)"
});

var _ref360 = /*#__PURE__*/React.createElement("path", {
  d: "M530.46 246.89h22.08a22.56 22.56 0 01.42-4.37 4.74 4.74 0 01.2-.86c.08-.27.15-.53.21-.79s.19-.44.27-.66l.11-.32.14-.26.25-.52c.09-.13.18-.26.26-.4l.11-.19.13-.14a2.73 2.73 0 00.21-.3 4.25 4.25 0 01.69-.58 1.84 1.84 0 01.62-.26.46.46 0 00.2 0 4.2 4.2 0 01.69.13 4.08 4.08 0 011 .59 8 8 0 011.28 1.19c.19.31.43.55.63.88s.43.63.61 1a19.87 19.87 0 011.86 5.37 38.21 38.21 0 01.62 6.69l.06 2.63.08 3.27c.06 1.32 0 2.83.19 4.61l.46 6c.18 2.22.6 4.7 1 7.37.15 1.34.48 2.75.77 4.22s.6 3 1 4.57l1.41 4.92.37 1.28.48 1.3 1 2.66a53.18 53.18 0 002.43 5.52 57 57 0 003.16 5.69 28.34 28.34 0 001.91 2.85c.69.94 1.37 1.9 2.1 2.85a69.16 69.16 0 005 5.41c7.1 7.17 16.42 12.17 24.75 16.82a83.4 83.4 0 0111.42 7.34 32.7 32.7 0 018.17 9.39 44 44 0 014.71 13.35l.65 4c.2 1.34.27 2.77.41 4.17l.2 2.12.06 2.2.13 4.45H657l-.14-5.32-.09-2.63-.23-2.66c-.18-1.77-.28-3.5-.53-5.26l-.86-5.24a66.18 66.18 0 00-7.26-20.15 54.92 54.92 0 00-13.48-15.6 104.17 104.17 0 00-14.43-9.37c-8.86-4.9-15.61-8.73-20.11-13.35a45.77 45.77 0 01-3.18-3.44l-1.31-1.82a14.35 14.35 0 01-1.22-1.81 33.55 33.55 0 01-2.07-3.74 32.5 32.5 0 01-1.66-3.79l-.71-1.88-.35-.92-.27-1-1-3.67c-.28-1.22-.5-2.43-.75-3.58s-.5-2.23-.62-3.35c-.27-2.22-.63-4.2-.78-6.08l-.39-5.09c-.16-1.5-.11-2.87-.16-4l-.07-2.88-.06-2.31A60 60 0 00584.1 242a41.41 41.41 0 00-4.1-11.45c-.47-.94-1.11-1.88-1.68-2.81s-1.33-1.83-2-2.72a29.58 29.58 0 00-5.23-4.91 25.87 25.87 0 00-6.81-3.61 25.27 25.27 0 00-8.08-1.36h-.84a22.82 22.82 0 00-2.49.23 23.86 23.86 0 00-9.23 3.48 25.88 25.88 0 00-5.35 4.57l-1.2 1.49-.6.78-.53.82-1.07 1.71c-.31.58-.61 1.18-.92 1.8l-.46.95-.37 1-.75 2a39 39 0 00-1.07 4.13 44.64 44.64 0 00-.86 8.79z",
  fill: "url(#hero_svg__bJ)"
});

var _ref361 = /*#__PURE__*/React.createElement("path", {
  d: "M529.11 245.86l-.09-9.64c0 3.31 5.43 6 12.19 6.09s12.25-2.6 12.27-5.9l.1 9.63c-.06 7.35-24.52 7.17-24.47-.18zM633.53 381l-.1-9.63c0 3.3 5.44 6 12.2 6.09s12.24-2.6 12.27-5.9l.09 9.63c-.05 7.35-24.51 7.16-24.46-.19z"
});

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 769.55 641.03",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361);
}

export default __webpack_public_path__ + "static/hero.b35254b4.svg";
export { SvgHero as ReactComponent };